import {HashRouter, Routes, Route, Navigate, BrowserRouter, Router} from 'react-router-dom'
import Home, {atomHomeLeftMenu} from './views/Home/HomeIndex'
import HomeIndex from './views/Home/views/CanvasListIndex/CanvasListIndex'
import List from './views/Home/views/list'
import Trash from './views/Home/views/Trash/TrashIndex'
import Note from './views/Note/NewNoteIndex'
import Draw, {PROJECT_ID} from './views/Draw/DrawIndex'
import NotePdf from './views/NotePdf'
import {getNoteName, noteServer} from '@/common/notesServer'
import { confirmServer } from '@/common/confirmServer'
import {ConfigProvider, Dropdown, message, Spin,Image} from 'antd'
import React, {useEffect, useRef, useState} from 'react'
import {postMessage, recvMessage, unSubscribe, useEventListener} from "@/common/event";
import {initLanguage, isZh, switchLanguage} from "@/language";
import "./publish.css"
import {getSysConfig, updateSysConfig} from "@model/sysconfig";
import {
  ACCESS_TOKEN,
  APP_NAME,
  arrayLanguages,
  COLOR_E5E5E5,
  DB_AUTO_BACKUP_TIME,
  DEFAULT_AUDIO_HEIGHT,
  DEFAULT_AUDIO_WIDTH,
  DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT,
  DEFAULT_EMBEDABLE_ELEMENT_HEIGHT,
  DEFAULT_HOME_LEFT_MENU,
  DEFAULT_NOTE_HEIGHT, DEFAULT_NOTE_HEIGHT_2,
  DEFAULT_NOTE_WIDTH,
  DEFAULT_SLIDER_WIDTH,
  DESKTOP_PRO_FROM_IMPORT_BACKUP_FILE,
  EVENT_ADD_NOTE,
  EVENT_CARD_BLOCK_JUMP,
  EVENT_DIALOG_DRAW_INDEX_ISFULLSCREEN,
  EVENT_FAVIRIATE_CHANGE, EVENT_LANGUAGE_CHANGED,
  EVENT_LICENSE_ACTIVE_TIPS,
  EVENT_NOTE_CHANGED, EVENT_NOTE_ON_SLIDER_RIGHT,
  EVENT_OPEN_LIBRARY_ITEM,
  EVENT_OPEN_OUT_APP_DATA,
  EVENT_ORIGIN_KEY,
  EVENT_PDF_ON_SLIDER_RIGHT,
  EVENT_REFRESH_CANVAS,
  EVENT_REFRESH_INFO_TAG,
  EVENT_REFRESH_LIBRARY_LIST,
  EVENT_REFRESH_LIBRARY_TAG_LIST,
  EVENT_REFRESH_LOGIN_STATUS,
  EVENT_REFRESH_PDF_ANNO_COMMENT,
  EVENT_REFRESH_PDF_HIGHLIGHT,
  EVENT_REFRESH_RECENTS,
  EVENT_RESET_NO_SELECTED,
  EVENT_RESET_NOTE_DATA,
  EVENT_SHOW_COMMON_INPUT,
  EVENT_SHOW_DESKTOP_PRO_VIP,
  EVENT_SHOW_DIALOG_DRAWINDEX,
  EVENT_SWITCH_HOME_LIST_MENU,
  EVENT_UPDATE_CANVAS_NOTE_TO_DB,
  FROM_HOME,
  FROM_HOME_DIALOG,
  FROM_HOME_LIBRARY,
  FROM_JOURNAL,
  FROM_LIBRARY,
  getNoteElementBackgroundColor,
  getNoteElementStrokeColor,
  IMPORT_FILE_MODE_ASKME,
  INIT_ID_GETTING_START_0,KEY_AUTO_BACKUP_INTERVAL,
  KEY_AUTO_BACKUP_PATH,
  KEY_AUTO_SAVE_CLOUD_DB, KEY_CARD_ELEMENT_DEFAULT_STYLE,
  KEY_DEFAULT_PROJECT_ID,
  KEY_ENABLE_AUTO_BACKUP,
  KEY_FILE_DIR,
  KEY_FILE_IMPORT_MODE,
  KEY_FILTER_SELECT_TAG,
  KEY_GLOBAL_SYNC_AUTO_SYNC_CLOSE_APP,
  KEY_HAS_DEFAULT_HOME,
  KEY_HAS_INITED,
  KEY_HAS_INITED_OLD_PROJECT,
  KEY_HOME_LEFT_MENU_CUSTOMIZE,
  KEY_HOME_SELECT_ITEM,
  KEY_IS_ENABLE_SYNC,
  KEY_JOURNAL_SELECT_DATE,
  KEY_LAST_BACKUP_TIME,
  KEY_LAUNCH_TIMES,
  KEY_MACHINEID,
  KEY_SELECT_RIGHT_SLIDER_MENU,
  KEY_SLIDER_RIGHT_WIDTH,
  KEY_UPGRADE_DATA_20240717,
  KEY_UPGRADE_DATA_20241030,
  KEY_UPGRADE_DATA_20241206,
  KEY_UPGRADE_DATA_20241219,
  KEY_WEB_MACHINEID, LASTEST_NOTE_DOC,
  MAX_Z_INDEX, SYS_CONFIG_KEY_LANGUAGE_CODE,
  SYS_CONFIG_KEY_THEME,
  THEME_DARK,
  TITLE_BAR_HEIGHT
} from "@/Const";
import {ipcInvoke, ipcOn, ipcRemoveThisAll, ipcSend} from "@/common/ipc";
import * as events from "events";
import Global from "@/global"
import {APP_WEB, APP_WEB_SITE, APP_WEB_WWW, DEBUG, isWeb, isWebApp} from "@/electron_interactive";

import ImagePreview from '@/components/ImagePreiew'
import NewNote from './NewNote'
import {atom, useAtom} from "jotai";
import {closeEditor, FullScreen, openEditor, ShowEditor} from './state'
import {ARRAY_SVG_INFO} from "@/iconsvg";
import RightMenu from '@/components/RightMenu'
import {fontInfoList} from "@model/fontInfo";
import {FONT_FAMILY} from "../@excalidraw/packages/excalidraw";
import {t} from "i18next";
import global from "@/global";
import DialogMessageBox from "@/common/DialogMessageBox";
import {getNoteById, getNoteDoc, getNoteJsonDoc, updateNote, updateNoteDoc} from "@model/note";
import {
  calcTextAreaHeight, calcTextHeight,
  calcVideoAnnoHeight, checkIfAbsolute,
  createCopyLink, createDeeplink,
  createEmptyProject, createFileElementHtml, createPdfAnnoTextElement,
  decodeDeeplink, formatDate,
  generateRandomPageKey,
  generateUUID,
  generateUUID2,
  getBase64ImageSize,
  getFileName,
  getFileNameExt, getFileNameWithoutExt, getImageExt, getImagePathWithTheme,
  getIntValueFromLocalStrage, getLocalFilePath,getSafeInt,
  getSelectionCoords,
  getUrlQueryParam,
  getVideoScale,
  hasBeyondFreeLimit, hasDesktopBaseLicense,
  hasLicense, imgPathPerfix, isAbsoluteFilePath,
  isArray, isAudio, isCardEmpty, isImage, isInDraw,
  isInIFrameApp, isInPageTag, isLiveVideoType, isPdf, isString,
  isStringNullOrEmpty, isSupportVideoAnnoUrl, isSupportVideoType, isSvg,
  isVideo,
  logger, revokeBlobObjectURL
} from "@/utils";
import DialogDesktopPro from "@/views/Draw/DialogDesktopPro";
import PageLibrary from "@/views/Library/PageLibrary";
import {
  updateCanvasToLibrary,
  updateUpGradeData,
  upgradeHighlight, upgradePdfAnnoToLibrary,
  upgradeProjectDocToJson,
  upgradeProjectHistoryToFile
} from "@/UpgradeUtils";
import FileModal from "@/components/Pdf/compoents/FileModal";
import PageTags from "@/views/Tags/PageTags";
import PageInbox from "@/views/Inbox/PageInbox";
import MessageTip from "@/common/MessageTip";
import {getCardById, getCardByIds, getCardDoc, getLibraryByLibraryId, updateCard} from "@model/card";
import DialogProgress from "@/views/Draw/DialogProgress";
import Login from "@/Login";
import Page404 from "@/Page404";
import DialogInfos from "@/views/Draw/DialogInfos";
import DialogDrawIndex from "@/views/DialogDrawIndex";
import DialogTagManager from "@/views/Dialog/DialogTagManager";
import {KEYS} from "../@excalidraw/packages/excalidraw/keys";
import {
  createBreadcrumb,
  createDeeplinkView,
  deepLinkToLinkInfo, getCardPath,
  getCardTitle,
  getDrawPath,
  isAutoEnableSync, isInSingleFloatWindow,
  isMac
} from "@/Utility";
import {deviceActive, getUserInfo} from "@/api/Api";
import LinkPage from "@/components/EditorV2/Link";
import PopupCardList from "@/components/EditorV2/PopupCardList";
import PageJournal from "@/views/Journal/PageJournal";
import DialogCommonInput from "@/common/DialogCommonInput";
import PopupLatexBlock from "@/components/EditorV2/latexMath/PopupLatexBlock";
import PageHighlight from "@/views/Highlight/PageHighlight";
import VideoNotes from "../@excalidraw/packages/excalidraw/components/VideoNotes/VideoNotes";
import {videoCache} from "../@excalidraw/packages/excalidraw/components/App";
import DialogImportHighlight from "@/views/DialogImportHighlight";
import PageCard from "@/views/Note/PageCard";
import {createBrowserHistory, createHashHistory} from "history";
import PagePdf from "@/views/Pdf/PagePdf";
import {ROUNDNESS} from "../@excalidraw/packages/excalidraw/constants";
import DialogChooseProject from "@/views/Dialog/DialogChooseProject";
import {exportDb, reOpenDb} from "@model/init";
import DialogCardHistory from "@/views/Note/DialogCardHistory";
import DialogProjectHistory from "@/views/Draw/DialogProjectHistory";
import DialogFileImportModeLoading from "@/views/Draw/DialogFileImportModeLoading";
import DialogDragFileImportMode from "@/views/Draw/DialogDragFileImportMode";
import DrawIndexSliderHeader from "@/views/Draw/DrawIndexSliderHeader";
import DrawIndexBreadcrumb from "@/views/Draw/DrawIndexBreadcrumb";
import Editor from "@/components/EditorV2";
import RightSlider from "@/RightSlider";
import {IconIndicatorBlue, IconIndicatorWhite} from "@/Icon";
import DialogMediaView from "@/views/Dialog/DialogMediaView";
import {dbGetHighlight, dbGetHighlightByLibraryId} from "@model/highlight";
import DialogPdfAnno from "@/views/Dialog/DialogPdfAnno";
import DialogVideoAnno from "@/views/Dialog/DialogVideoAnno";
import DialogLink from "@/views/Draw/DialogLink";
import {isLocalLink} from "../@excalidraw/packages/excalidraw/data/url";
import {clearProjectHistoryDoc} from "@model/projectHistory";
import DialogMindmapLinkMode from "@/views/Draw/Dialog/DialogMindmapLinkMode";
import SimpleEditor from "@/components/EditorV2/SimpleEditor";
import DialogAddToLibrary from "@/views/Dialog/DialogAddToLibrary";
import library from "../@excalidraw/packages/excalidraw/data/library";
import DialogChooseImage from "@/views/Draw/DialogChooseImage";
import DialogChooseCardPdf from './views/Draw/DialogChooseCardPdf'
import DialogPasteMediaAddTo from "@/views/Dialog/DialogPasteMediaAddTo";
import dialogPasteMediaAddTo from "@/views/Dialog/DialogPasteMediaAddTo";
import {getImageFileSize, getImageFileWH} from "../@excalidraw/packages/excalidraw/data/image";
import DialogLibraryImport from "@/views/Dialog/DialogLibraryImport";
import DialogWeblinkImport from "@/views/Dialog/DialogWeblinkImport";
import DialogGlobalSearch from "@/views/Dialog/DialogGlobalSearch";
import DialogCreateNewFilter from "@/views/Dialog/DialogCreateNewFilter";
import DialogMindmapStyleSetting from "@/views/Dialog/DialogMindmapStyleSetting";
import DialogImageCrop from "@/views/Dialog/DialogImageCrop";
import DialogTypeSwitcherSetting from "@/views/Dialog/DialogTypeSwitcherSetting";
import {loop, loopAllNode} from "@/TreeUtils";
import {createPortal} from "react-dom";
import DialogChooseProjectLinkImage from "@/views/Dialog/DialogChooseProjectLinkImage";
import DialogAddLink from "@/views/Dialog/DialogAddLink";
import PageProperty from "@/views/Property/PageProperty";
import DialogAddProperty from "@/views/Property/DialogAddProperty";
import PageTask from "@/views/Task/PageTask";
import DatePickerProvider from './components/DatePickerPop/DatePickerManager'
import DialogAddView from "@/views/Property/DialogAddView";
import TagItemList from "@/views/Tags/TagItemList";
import DialogRelatedProperty from "@/views/Property/DialogRelatedProperty";
import DialogChooseThumb from "@/views/Home/DialogChooseThumb";
import DialogMoveTo from "@/views/Dialog/DialogMoveTo";
import {deleteBoardById, getBoardById, updateBoard} from "@model/board";
import {nanoid} from "nanoid";
import PageTagItemList from "@/views/Tags/PageTagItemList";
import DialogWebBrowseAddBookmark from "@/views/Dialog/DialogWebBrowseAddBookmark";
import DialogFramePreview from "@/views/Dialog/DialogFramePreview";
import {editDoc} from "@model/doc";
import DialogPublishCardToWeb from "@/views/Dialog/DialogPublishCardToWeb";
import DialogImportTranscript from "@/views/DialogImportTranscript";
import dialogImportTranscript from "@/views/DialogImportTranscript";
import DialogEditTranscript from "@/views/Dialog/DialogEditTranscript";
import DialogReplace from "@/views/Dialog/DialogReplace";
import DialogImportMindmapFromMarkdown from "@/views/Dialog/DialogImportMindmapFromMarkdown";
import TemplateDialogProvider from './components/TemplateDialog/TemplateManager';
import TemplateSelectorProvider from './components/TemplateDialog/TemplateSelector';
import {project} from "../@excalidraw/packages/excalidraw/gapoints";
import DialogTiptapTextEditor from "@/views/Dialog/DialogTiptapTextEditor";
import dialogTiptapTextEditor from "@/views/Dialog/DialogTiptapTextEditor";
import DialogBoardVisible from "@/views/Dialog/DialogBoardVisible";
import dialogBoardVisible from "@/views/Dialog/DialogBoardVisible";


let mIsNeedInitData = false;
export const mIsDialogDrawIndexFullScreen = atom<boolean>(false);
let mIsShowTips = false;
let mLatexBlockOnChange:any;
let mszDefaultLatexBlockContent:any;
let mEditor:any;
let mProjectInfo:any;
let mShowImportFileProgressTime:any;
let mFileSelectCallback:any;
let mImportMode:any;
let mAutoBackupTimer:any;
// let mHasDefaultHome:any = false;
let mDialogLinkCallback:any;
let mDialogZIndex = 2001;
let mDialogChooseCardPdfCallback:any;

export const atomSliderWidth = atom(0);
export const atomHasDefaultHomePage = atom(false);

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 * localStorage.setItem
 * 如果直接强制重启了应用，这个东西之前保存的数据不会被保存？？？？？比如改了数据后强制重新运行，之前的数据又回来了？
 * @constructor
 */

const App = () => {

  const [showEditor, setShowEditor] = useAtom(ShowEditor)
  const [fullScreen, setFullScreen] = useAtom(FullScreen)
  const [isShowDialogDesktopPro,setIsShowDialogDesktopPro] = useState(false);
  const dialogMessageBoxRef = useRef(null);
  const dialogDesktopProRef = useRef(null);
  const messageTipRef = useRef(null);
  const dialogProgressRef = useRef(null);
  const dialogProgressRef1 = useRef(null);
  const dialogInfosRef = useRef(null);
  const [isShowDialogInfos,setIsShowDialogInfos] = useState(false);
  const [isShowDialogDrawIndex,setIsShowDialogDrawIndex] = useState(false);
  const [linkInfo,setLinkInfo] = useState(null)
  const [isDialogDrawIndexFullScreen,setIsDialogDrawIndexFullScreen] = useAtom(mIsDialogDrawIndexFullScreen);
  const [linkPosition,setLinkPosition] = useState({left:'0px',top:'0px'});
  const [isShowCardList,setIsShowCardList] = useState(false);
  const [isShowLatexBlock,setIsShowLatexBlock] = useState(false);
  const [videoNotes,setVideoNotes] = useState({visibility:false,type:'model',element:null})
  const [isShowCardHistory,setIsShowCardHistory] = useState(false);
  const [isShowProjectHistory,setIsShowProjectHistory] = useState(false);
  const [isShowFileImportLoading,setIsShowFileImportLoading] = useState(false);
  const [isShowDialogFileImportModeDrag,setIsShowDialogFileImportModeDrag] = useState(false);
  const [isShowDialogMediaView,setIsShowDialogMediaView] = useState(false);
  const [isShowDialogPdfAnno,setIsShowDialogPdfAnno] = useState(false);
  const [isShowDialogVideoAnno,setIsShowDialogVideoAnno] = useState(false);
  const [isShowDialogLink,setIsShowDialogLink] = useState(false);
  const [isShowDialogMindmapLinkMode,setIsShowDialogMindmapLinkMode] = useState(false);
  const [isShowDialogMindmapStyleSetting,setIsShowDialogMindmapStyleSetting] = useState(false);
  const [isShowDialogTypeSwitcherSetting,setIsShowDialogTypeSwitcherSetting] = useState(false);
  const [isShowDialogImportHighlight,setIsShowDialogImportHighlight] = useState(false);
  const [isShowDialogImportTranscript,setIsShowDialogImportTranscript] = useState(false);
  const [isShowDialogAddToLibrary,setIsShowDialogAddToLibrary] = useState(false);
  const [isShowDialogPasteMediaAddTo,setIsShowDialogPasteMediaAddTo] = useState(false);
  const [isShowDialogChooseImage,setIsShowDialogChooseImage] = useState(false);
  const [isShowDialogChooseCardPdf,setIsShowDialogChooseCardPdf] = useState(false);
  const [isShowDialogLibraryImport,setIsShowDialogLibraryImport] = useState(false);
  const [isShowDialogWeblinkImport,setIsShowDialogWeblinkImport] = useState(false);
  const [isShowDialogGlobalSearch,setIsShowDialogGlobalSearch] = useState(false);
  const [isShowDialogCreateNewFilter,setIsShowDialogCreateNewFilter] = useState(false);
  const [fileAcceptExt,setFileAcceptExt] = useState('*.*');
  const [isShowDialogChooseProject,setIsShowDialogChooseProject] = useState(false);
  const [isShowVideoPreview,setIsShowVideoPreview] = useState(false);
  const [isShowDialogImageCrop,setIsShowDialogImageCrop] = useState(false);
  const [isShowDialogChooseImageNew,setIsShowDialogChooseImageNew] = useState(false);
  const [isShowDialogAddLink,setIsShowDialogAddLink] = useState(false);
  const [isShowDialogAddProperty,setIsShowDialogAddProperty] = useState(false);
  const [isShowDialogAddView,setIsShowDialogAddView] = useState(false);
  const [isShowDialogFramePreview,setIsShowDialogFramePreview] = useState(false);
  const [isShowDialogPublishCard,setIsShowDialogPublishCard] = useState(false);
  const [isShowDialogEditTranscript,setIsShowDialogEditTranscript] = useState(false);
    const [isShowDialogReplace,setIsShowDialogReplace] = useState(false);

  const [imagePreviewInfo,setImagePreviewInfo] = useState({visible:false,src:''})
  const [arrayDialogCards,setArrayDialogCards] = useState<any>([]);
  const [arrayDialogPdfs,setArrayDialogPdfs] = useState<any>([]);
  const [arrayDialogVideos,setArrayDialogVideos] = useState<any>([]);
  const [arrayDialogMedia,setArrayDialogMedia] = useState<any>([])
  const [arrayDialogTiptapEditor,setArrayDialogTiptapEditor] = useState<any>([]);
  const [tipsInfo,setTipsInfo] = useState<any>(null);
  const [showAddANoteData,setShowAddANoteData] = useState<any>(false);

  const [isShowMessageTipInfo,setIsShowMessageTipInfo] = useState(false);
  const [isShowDialogRelatedProperty,setIsShowDialogRelatedProperty] = useState(false);
  const [isShowDialogChooseThumb,setIsShowDialogChooseThumb] = useState(false);
  const [isShowDialogMoveTo,setIsShowDialogMoveTo] = useState(false);
  const [isShowDialogWebBrowseAddBookmark,setIsShowDialogWebBrowseAddBookmark] = useState(false);
    const [isShowDialogImportMindmapFromMarkdown,setIsShowDialogImportMindmapFromMarkdown] = useState(false);
    const [isShowDialogBoardVisible,setIsShowDialogBoardVisible] = useState(false);


  const [hasDefaultHome,setHasDefaultHome] = useAtom(atomHasDefaultHomePage);
  const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
  const [homeLeftMenu,setHomeLeftMenu] = useAtom(atomHomeLeftMenu);

  const dialogTagManagerRef = useRef(null);
  const dialogDrawIndexRef = useRef(null);
  const dialogCardLinkPageRef = useRef(null);
  const dialogImportHighlightRef = useRef(null);
  const dialogImportTranscriptRef = useRef(null);
  const dialogChooseProjectRef = useRef(null);
  const dialogCardHistoryRef = useRef(null);
  const dialogProjectHistoryRef = useRef(null);
  const dialogFileImportLoadingRef = useRef(null);
  const dialogDragFileImportModeRef = useRef(null);
  const dialogMediaViewRef = useRef(null);
  const dialogPdfAnnoRef = useRef(null);
  const dialogVideoAnnoRef = useRef(null);
  const fileSelectRef = useRef(null);
  const dialogLinkRef = useRef(null);
  const dialogMindmapLinkModeRef = useRef(null);
  const dialogAddToLibraryRef = useRef(null);
  const dialogChooseImageRef = useRef(null);
  const dialogChooseCardPdfRef = useRef(null);
  const dialogPasteMediaAddToRef = useRef(null);
  const dialogLibraryImport = useRef(null);
  const dialogWeblinkImport = useRef(null);
  const dialogGlobalSearchRef = useRef(null);
  const dialogCreateNewFilterRef = useRef(null);
  const dialogMindmapStyleSettingRef = useRef(null);
  const dialogImageCropRef = useRef(null);
  const dialogTypeSwitcherSettingRef = useRef(null);
  const dialogChooseProjectLinkImageRef = useRef(null);
  const dialogAddLinkRef = useRef(null);
  const dialogAddPropertyRef = useRef(null);
  const dialogAddViewRef = useRef(null);
  const dialogRelatedPropertyRef = useRef(null);
  const dialogChooseThumbRef = useRef(null);
  const dialogMoveToRef = useRef(null);
  const dialogWebBrowseAddBookmarkRef = useRef(null);
  const dialogFramePreviewRef = useRef(null);
  const dialogPublishToWebRef = useRef(null);
  const dialogEditTranscriptRef = useRef(null);
    const dialogReplaceRef = useRef(null);
    const dialogImportMindmapFromMarkdownRef = useRef(null);
    const dialogBoardVisibleRef = useRef(null);

  const editorRef = useRef(null);
  const dialogInputRef = useRef(null);
  let latexBlockProps = useRef(null);
  let mIsPopupCardListFromAt = useRef<any>(null);

  const rightSliderRef = useRef(null);
  const simpleEditorRef = useRef(null);

  /**
   * 卡片的引用
   */
  const dialogCardRefs = useRef<any>([]);
  /**
   * pdf的引用
   */
  const dialogPdfRefs = useRef<any>([]);
  /**
   * 视频的引用
   */
  const dialogVideoRefs = useRef<any>([]);

  const dialogMediaRefs = useRef<any>([])

  /**
   * 画布上 文本和stickynote的
   */
  const dialogTiptapTextEditorRefs = useRef<any>([]);


  const [fileState, setFileState] = useState({
    open: false,
    fileName: '',
    fileId: '',
    filePath: "",
    isFullScreen:false,
    isViewAllHighlight:false,
    isShowMoreMenu:true,
    highlightId:''
  })

  const [load, setLoad] = useState({
    spinning: false,
    tip: ''
  })
  const [loadSpin, setLoadSpin] = useState({
    spinning: false,
    tip: ''
  })

  window.title = t("Home")

  useEventListener('show-load',({detail})=>{
    // setLoad({
    //   spinning:true,
    //   tip: detail || ''
    // })
  })
  useEventListener('hide-load',()=>{
    // setLoad({
    //   spinning:false,
    //   tip: ''
    // })
  })

  useEventListener('editor-show-change',({detail})=>{
    // setFullScreen(false)
    setShowEditor(detail)
  })

  useEventListener('set-fullscreen-atom--------',({detail})=>{
    setFullScreen(detail)
  })

  useEffect(()=>{
    // getSysConfig(SYS_CONFIG_KEY_THEME).then(res=>{
    //   let body = document.getElementsByTagName("body")[0];
    //   if(res != undefined && res.value){
    //     const szThemeName = res.value + '-theme';
    //     body.className = szThemeName;
    //   }else{
    //     body.className = 'light-theme';
    //   }
    // })
    // 渲染进程 renderer.js
    window.onerror = (message, source, lineno, colno, error) => {
      console.error('Renderer Error:', error);
      logger(error);
      logger(error?.stack)
    };



    recvMessage(EVENT_LICENSE_ACTIVE_TIPS,(msg,data)=>{
      dialogMessageBoxRef.current?.onShowDialogWithoutCancel(t("Device limit"),t("YouHaveReachedMaximum"),t("Confirm"),()=>{

      })
    },true);

    /**
     * vip弹窗-------
     */
    recvMessage(EVENT_SHOW_DESKTOP_PRO_VIP,(msg,data)=>{
      // setIsShowDialogDesktopPro(true);
      // setTimeout(()=>{
      //   dialogDesktopProRef.current?.onShowDialog(data.data.from)
      // },100);
      //换成messagebox  2025-01-06
      window.showMessageBox(t("Upgrade required"),t("YouNeedToUpgradeToCreateMoreProject"),t("Cancel"),t("Get more"),null,()=>{
        if (isZh()) {
          ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH);
        }else {
          ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE);
        }
      })
    })


    recvMessage(EVENT_SHOW_DIALOG_DRAWINDEX,async (msg,data)=>{
      if (isInSidebar()){
        message.error(t("NotSupportInSidebar"));
        return;
      }
      setIsDialogDrawIndexFullScreen(false);
      // window.parent.postMessage({action:EVENT_DIALOG_DRAW_INDEX_ISFULLSCREEN,isFullScreen:false})
      // closeEditor();
      // setLinkInfo(data.data.linkInfo);
      // setIsShowDialogDrawIndex(true);
      if (data.data.inSlider){
        //右侧栏打开
        getNoteById(data.data.linkInfo.id).then(res=>{
          rightSliderRef.current?.onOpenSlider(res,'project',data.data.linkInfo);
        })
      }else{
        const project = await getNoteById(data.data.linkInfo.id,true,true);
        if (data.data.linkInfo.pageId){
          //判断这个board是否存在.
          let isExist = false;
          loop(project.doc.canvas,data.data.linkInfo.pageId,(node, i, data, parent)=>{
            isExist = true;
          })
          if (!isExist){
            message.error('BoardNotExist')
            return;
          }
        }
        if (data.data.linkInfo.isCurrentProject && data.data.linkInfo.type == 'element' && isInDraw() && window.onNavDeepLink){
          window.onNavDeepLink(data.data.linkInfo)
        }else{
          //直接转到项目
          window.navigate(getDrawPath(),{linkInfo:data.data.linkInfo});
        }
      }


      postMessage(EVENT_RESET_NO_SELECTED);
      postMessage(EVENT_REFRESH_RECENTS)
    })

    //打开library中的内容
    recvMessage(EVENT_OPEN_LIBRARY_ITEM,async (msg,data)=>{
      const library:any = await getCardById(data.data.id,true);
      if (!library || library?.isDeleted == 1){
        message.error(t('Invalid link'))
        return;
      }
      if (!data.data.deeplink){
        data.data.deeplink = createDeeplink(library);
      }
      if (data.data.inSlider){
        //region 侧栏打开....
        if (library.type == 'card' || library.type == 'journal') {
          if (data.data.deeplink.childType == 'card'){
            //card中的block
            sessionStorage.setItem('block-id',data.data.deeplink.childId);
            sessionStorage.setItem('block-type',data.data.deeplink.elementType);
          }
          if (library.type == 'card'){
            localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU,'library');//定位到library....
          }else{
            localStorage.setItem(KEY_SELECT_RIGHT_SLIDER_MENU,'library');//定位到journal....
          }
          if (APP_WEB || global.g_isPresentMode){
            postMessage(EVENT_NOTE_ON_SLIDER_RIGHT,{data:library});
          }else{
            rightSliderRef.current?.onOpenSlider(library,library.type,{forceType:'library'});
          }
        }else if (library.type == 'pdf') {
          rightSliderRef.current?.onOpenSlider(library,library.type);
        }else if (library.type == 'video' || library.type == 'audio' || isSupportVideoType(library.type)){
          let szType = library.type;
          if (szType == 'youtube'){

          }
          if (data.data?.deeplink?.childType == 'transcript'){
            //字幕的链接....
            rightSliderRef.current?.onOpenSlider(library,library.type,{type:'transcript',selectedId:data.data.selectedId});
          }else{
            rightSliderRef.current?.onOpenSlider(library,library.type,{selectedId:data.data.selectedId});
          }

        }else if (library.type == 'pdfAnno' || library.type == 'cardAnno' || library.type == 'videoAnno' || library.type == 'audioAnno'){
          const dbLibrary:any = await getCardById(library.libraryId);
          dbLibrary.annoId = library.id;
          rightSliderRef.current?.onOpenSlider(dbLibrary,dbLibrary.type,{highlightId:library.id,selectedId:library.id});
        }else if (library.type == 'image'){
          window.showDialogMediaView(library);
        }else{
          //文件？
          let szFilePath = localStorage.getItem(KEY_FILE_DIR) + library.fileName;
          if (library.isAbsolutePath || isAbsoluteFilePath(library.fileName)){
            szFilePath = library.fileName;
          }
          ipcInvoke('open-url-withwhen',szFilePath).then(res=>{
            if (res == 'error'){
              message.error(t("Open error"));
            }
          })
        }
        //endregion
      }else{
        if (library.type == 'card' || library.type == 'journal') {
          if (data.data.isOpenInPage){
            //全屏的打开.
            if (library.type == 'card'){
              window.navigateOrigin(getCardPath(),{state:{cardId:library.id}})
            }else{
              window.navigateOrigin("/home/journal",{state:{id:library.id},replace:true});
            }
          }else{
            if (data.data.deeplink.childType == 'card'){
              //card中的block
              sessionStorage.setItem('block-id',data.data.deeplink.childId);
              sessionStorage.setItem('block-type',data.data.deeplink.elementType);
            }
            Global.g_currentNoteData = {...library};
            openEditor(library.id,false,false,data.data.from);
            // postMessage(EVENT_RESET_NOTE_DATA,{card:library})
            postMessage(EVENT_CARD_BLOCK_JUMP,{childId:data.data.deeplink.childId,elementType:data.data.deeplink.elementType});
          }
        } else if (library.type == 'pdf') {
          window.showPdfPreview(library.name, library.id, library.fileName);
        }else if (library.type == 'image' || library.type == 'video' || library.type == 'audio' || isSupportVideoType(library.type)){
          //图片或视频--打开方式千Q百G
          if (library.type == 'audio'){
            if (data.data?.deeplink?.childType == 'transcript'){
              //字幕的链接....
              window.showVideoNotes({
                ...library,
                data: [],
                type: library.type || 'youtube'
              }, {type:'transcript',selectId:data.data.selectedId});
              return;
            }else{
              window.showVideoNotes({
                ...library,
                data: [],
                type: library.type || 'youtube'
              });
              return;
            }
          }
          if (data.data?.deeplink?.childType == 'transcript'){
            //字幕的链接....
            window.showVideoNotes(library, {type:'transcript',selectId:data.data.selectedId});
            return;
          }
          const highlight = await dbGetHighlightByLibraryId(library.id);
          if (highlight && highlight.data.length > 0) {//有视频注记，用视频注记打开
            if (library.type == 'videoAnno'){
              window.showVideoNotes(highlight,library.id);
            }else{
              window.showVideoNotes(highlight,data.data.selectedId);
            }
          }else {
            if (isLiveVideoType(library.type)){
              window.showVideoNotes({...library,data:[],type:library.type || 'youtube'});
            }else{
              window.showDialogMediaView(library);
            }
          }
        }else if (library.type == 'pdfAnno'){
          if (data.data.openInDialogAnno){
            window.showDialogPdfAnno(library);
          }else{
            const dbLibrary:any = await getCardById(library.libraryId);
            window.showPdfPreview(dbLibrary.name,dbLibrary.id,dbLibrary.fileName,false,true,true,{highlightId:library.id});
          }
        }else if (library.type == 'cardAnno'){
          if (data.data.openInDialogAnno){
            window.showDialogPdfAnno(library);
          }else{
            openEditor(library.libraryId,true,true,'','card',library.id);
          }
        }else if (library.type == 'webLink'){
          ipcSend('open-url',library.fileName);
        }else if (library.type == 'videoAnno' || library.type == 'audioAnno'){
          if (data.data.openInDialogAnno){
            window.showDialogVideoAnno(library);
          }else{
            const highlight = await dbGetHighlight(library.libraryId);
            if (highlight) {
              window.showVideoNotes(highlight,library.id)
            }
          }
        }
        else {
          const szFilePath = (library.isAbsolutePath?'':localStorage.getItem(KEY_FILE_DIR)) + library.fileName;
          ipcInvoke('open-url-withwhen', szFilePath).then(res => {
            if (res == 'error') {
              message.error(t("Open error"));
            }
          })
        }
      }
    })

    /**
     * 通用输入框
     */
    recvMessage(EVENT_SHOW_COMMON_INPUT,(msg,data)=>{
      dialogInputRef.current?.onShowDialogAll(data.data.name,data.data.title,t("Cancel"),t("Ok"),(szContent:any)=>{
        data.data.callback(szContent)
      },data.data.placeHolder || '')
    })

    initThemeData();

    //初始字体列表
    initFontFamilyList();

    //对于web生成一个唯一id...删了就重置。。。。
    if (!localStorage.getItem(KEY_WEB_MACHINEID)){
      localStorage.setItem(KEY_WEB_MACHINEID,generateUUID())
    }

    if (!isWeb() && !mIsNeedInitData){
      //更新要升级的数据...
      const isNeedUpdateLibrary = localStorage.getItem(KEY_UPGRADE_DATA_20240717);
      if (isStringNullOrEmpty(isNeedUpdateLibrary)/*&& localStorage.getItem(KEY_HAS_INITED)*/){
        setLoad({
          spinning:true,
          tip: 'Upgrading'
        })
        updateUpGradeData((fProgress:any)=>{
          setLoad({
            spinning: true,
            tip: 'Upgrading '+Math.round(fProgress*100)+'%'
          })
        }).then(res=>{
          setLoad({
            spinning:false,
            tip: 'Upgrading'
          })
        });
      }

      //升级hightlight
      const isNeedVideoNotes = localStorage.getItem(KEY_UPGRADE_DATA_20241030);
      if (!isNeedVideoNotes){
        upgradeHighlight();
      }
    }

    if (!isWeb()){
      //更新项目历史记录中的file-dataURL 为空.
      // if (localStorage.getItem(KEY_UPGRADE_DATA_20241205) != 'true' || DEBUG){
      //
      //   localStorage.setItem(KEY_UPGRADE_DATA_20241205,'true');
      // }

      if (localStorage.getItem(KEY_UPGRADE_DATA_20241206) != 'true' /*|| DEBUG*/){
        upgradeProjectHistoryToFile();
        upgradeProjectDocToJson();
        localStorage.setItem(KEY_UPGRADE_DATA_20241206,'true');
      }

      if (localStorage.getItem(KEY_UPGRADE_DATA_20241219) != 'true' /*|| DEBUG*/){
        upgradePdfAnnoToLibrary();
        localStorage.setItem(KEY_UPGRADE_DATA_20241219,'true');
      }

      //清项目历史记录。防止还在---
      clearProjectHistoryDoc()
    }

    //增加次数...
    const nLaunchTimes = getIntValueFromLocalStrage(KEY_LAUNCH_TIMES)
    localStorage.setItem(KEY_LAUNCH_TIMES,(nLaunchTimes+1)+'');

    let homeLeftMenu0 = {...DEFAULT_HOME_LEFT_MENU};

    const hasDefaultHome = localStorage.getItem(KEY_HAS_DEFAULT_HOME);
    if (hasDefaultHome == undefined){
      localStorage.setItem(KEY_HAS_DEFAULT_HOME,(nLaunchTimes==0)?'false':'true');
      if (nLaunchTimes == 0){
        homeLeftMenu0.home = true;//默认有首页
        localStorage.setItem(KEY_HOME_LEFT_MENU_CUSTOMIZE,JSON.stringify(homeLeftMenu0));
        //保存到数据库
        updateSysConfig(KEY_HOME_LEFT_MENU_CUSTOMIZE,homeLeftMenu0);
      }
    }

    //读取左侧菜单
    const szLeftMenu = localStorage.getItem(KEY_HOME_LEFT_MENU_CUSTOMIZE);
    if (szLeftMenu){
      homeLeftMenu0 = JSON.parse(szLeftMenu);
      if (homeLeftMenu0.properties == undefined){
        homeLeftMenu0.properties = true;
      }
    }

    setHasDefaultHome(homeLeftMenu0.home);
    setHomeLeftMenu(homeLeftMenu0);

    //每次从project开始...
    localStorage.removeItem(KEY_HOME_SELECT_ITEM);

    //设备ID
    if (!isWeb()){
      ipcInvoke("get-machineid").then(res=>{
        localStorage.setItem(KEY_MACHINEID,res);
      })

      ipcInvoke('get-convert-token').then(res=>{
        global.g_edit_md_token = res;
      })

      ipcInvoke('get-default-dir').then(res=>{
        global.g_defaultStorePath = res;
      })

      ipcInvoke('get-app-path').then(res=>{
        global.g_appPath = res;
      })

      //是否开启了同步云盘
      ipcSend('is-enable-cloud-sync',{isEnabledSync:isAutoEnableSync()})

      //文件目录--
      ipcInvoke("getUserDataDir").then(res=>{
        localStorage.setItem(KEY_FILE_DIR,res);
      })

      ipcInvoke("os-mac").then(res=>{
        window.isMac = res;
      })

      ipcSend('copy-main-note-image-to-files');

      ipcSend('set-origin',{origin:window.location.origin})

      //根base路径
      ipcInvoke('package-base-url').then(res=>{
        global.g_base_url = res;
      })

      ipcInvoke('get-convert-token').then(res=>{
        global.g_edit_md_token = res;
      })

      if (!localStorage.getItem(KEY_HAS_INITED) && !isInSingleFloatWindow()){
          global.g_isFirstRun = true;
        //初始化数据
        mIsNeedInitData = true;
        ipcInvoke('read-init-file', {fileName:"template/init/Home.pcanvasx"}).then(async (res)=>{
          const json = JSON.parse(res);
          // console.log(json);
          json.canvas[0].title = t("Board");
          json.info.title = t("Home");
          const note = {
            createTime: Date.now(),
            deleteTime: 0,
            doc: res,
            favirateTime: 0,
            id: KEY_DEFAULT_PROJECT_ID,
            img: json.info.cover,
            isDeleted: 0,
            isFavirated: 0,
            name: json.info.title,
            searchName: json.info.title,
            showName: json.info.title,
            updateTime: Date.now(),
            isDefaultProject:true,
          }
          //保存笔记的图片到本地...
          await ipcInvoke('save-image-to-local',JSON.stringify(json.notesImage));
          //保存插入的图片到本地
          if (json.files && json.files.length > 0){
            await ipcInvoke('write-base64-files',JSON.stringify(json.files))
          }

          //分离数据
          await updateCanvasToLibrary(json,true,(fProgress:any)=>{

          });
          note.doc = JSON.stringify(json);
          //保存并刷新
          updateNote(note).then(res=>{
            // postMessage(EVENT_NOTE_CHANGED);
            postMessage(EVENT_REFRESH_CANVAS,{note:note})
          })

          if (!localStorage.getItem(KEY_HAS_INITED_OLD_PROJECT)){
            //region two
            ipcInvoke('read-init-file', {fileName:"template/init/Getting Started.pcanvasx"}).then(async (res)=>{
              const json = JSON.parse(res);
              // await ipcInvoke('write-base64-image',{imgBase64:json.info.cover,fileName:INIT_ID_GETTING_START_0+".png"})
              // console.log(json);
              let szName = 'Getting Started';//json.info.title,
              const note = {
                createTime: Date.now(),
                deleteTime: 0,
                doc: res,
                favirateTime: 0,
                id: INIT_ID_GETTING_START_0,
                thumbUrl: `${INIT_ID_GETTING_START_0}.png`,//'thumbnail_bg_color 1_light.png',//
                isDeleted: 0,
                isFavirated: 0,
                name: szName,
                searchName: szName,
                showName: szName,
                updateTime: Date.now(),
              }
              //保存笔记的图片到本地...
              await ipcInvoke('save-image-to-local',JSON.stringify(json.notesImage));
              //保存插入的图片到本地
              if (json.files && json.files.length > 0){
                await ipcInvoke('write-base64-files',JSON.stringify(json.files))
              }

              //分离数据
              await updateCanvasToLibrary(json,true,(fProgress:any)=>{

              },{isSaveTag:true,isSaveProperty:true});
              note.doc = JSON.stringify(json);
              //保存并刷新
              updateNote(note).then(res=>{
                postMessage(EVENT_NOTE_CHANGED);
              })
            })
            //endregion
            localStorage.setItem(KEY_HAS_INITED_OLD_PROJECT,'true');
          }
        })

        localStorage.setItem(KEY_HAS_INITED,"true");
      }

      //默认是最大化
      window.isMaxSize = true;

      setTimeout(()=>{
        ipcInvoke("read-svg").then(res=>{
          Global.g_arraySvg = res;
        })
      },1500);
    }else{
      // @ts-ignore
      Global.g_arraySvg = ARRAY_SVG_INFO;
      localStorage.setItem(KEY_MACHINEID,'D-ID-WEB-APP')
    }

    ipcOn('show-loading-pcanvas',(event,args)=>{
      window.showProgress1(t('Loading'));
    })

    ipcOn("outopenapp-message",(event,args)=>{
      logger('recv outopenapp-message...');
      logger(args);

      if (args.hasOwnProperty("action")){
        let szArgs = args["obj"]??'';
        if (szArgs.indexOf("muenzo://") == 0){
          global.g_isRecvOutOpenAppMessage = true;
          // szArgs = szArgs.replace("muenzo:///?token=","").replace("muenzo://?token=","");//win上 3个/  mac上2个/  ????
          //取参数
          loginAndCheck(szArgs);
        }else if (szArgs.indexOf("noteey://") == 0 && global.g_handleCardDeeplink != szArgs){
          if (global.g_isRecvDeeplinkMessage) {
            console.log("global.g_isRecvDeeplinkMessage:true");
          }else{
            global.g_isRecvDeeplinkMessage = true;
            const deeplink = decodeDeeplink(szArgs);
            if (deeplink.type == 'project'){
              deepLinkToLinkInfo(deeplink).then(linkInfo=>{
                // postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo});
                postMessage(EVENT_SWITCH_HOME_LIST_MENU,{name:'draw',linkInfo:linkInfo})
              });
              // getNoteById(deeplink.id,false).then(res=>{
              //     const navigate = useNavigate();
              //     navigate('/home/draw', {state: {noteData: res}})
              // })
            }else if (deeplink.type == 'library'){
              postMessage(EVENT_OPEN_LIBRARY_ITEM,{id:deeplink.id,deeplink:deeplink,from:FROM_LIBRARY})
            }
          }
          //3s后置成false
          setTimeout(()=>{
            global.g_isRecvDeeplinkMessage = false;
          },3000)
        }
        else if(szArgs.endsWith(".pcanvas") || szArgs.endsWith(".pcanvasx")){
          //打开文件？
          window.showProgress1(t('Loading'));
          ipcInvoke("check-args",{filePath:szArgs}).then(args=>{
            if (args != undefined && args.hasOwnProperty("data")){
              // global.g_openOutData = {data:args.data,filePath:args.filePath};
              //发送消息，如果canvaslist 在，他处理。
              window.closeProgress1();
              window.onNavigateDraw(args.data,args.filePath);
            }
          })
        }
      }
    })

    //监听打开zip文件读取到数据库的消息
    ipcOn('outfile-read-db-data',(event,args)=>{
      if (args != undefined && args.hasOwnProperty("data")){
        // global.g_openOutData = {data:args.data,filePath:args.filePath};
        //发送消息，如果canvaslist 在，他处理。
        window.closeProgress1();
        window.onNavigateDraw(args.data,args.filePath);
      }
    })

    //监听窗口关闭...
    ipcOn('close-window', async (msg, data) => {
      //清空记录的日记时间---关闭应用的时候清空一些设置，本来是要持久保存的，又不用了.
      localStorage.removeItem(KEY_JOURNAL_SELECT_DATE);
      localStorage.removeItem(KEY_FILTER_SELECT_TAG);


      if (window.saveNotes){
        await window.saveNotes();
      }
      if (!isAutoEnableSync()){
        ipcSend('force-close-window');
        return;
      }
      //点击了checkbox的自动保存到网盘...
      const isAutoSave:any = localStorage.getItem(KEY_AUTO_SAVE_CLOUD_DB);
      //检测下时间，
      const checkData = await ipcInvoke('check-cloud-time');

      if (isAutoSave == 'true'){
        setLoad({
          spinning:true,
          tip:t('Closing')+'...'
        })

        if (checkData.isPanNew){
          window.showMessageBox(t("Tips"),t("LocalDataIsOld"),t("Cancel"),t("Confirm"),()=>{
            ipcSend('force-close-window',{dontUpdateTime:true});
          },()=>{
            window.backupDb().then(res=>{
              //强制关闭了...
              ipcSend('force-close-window');
            })
          })
        }else{
          window.backupDb().then(res=>{
            //强制关闭了...
            ipcSend('force-close-window');
          })
        }

      }else{
        let szAutoClose = localStorage.getItem(KEY_GLOBAL_SYNC_AUTO_SYNC_CLOSE_APP) || 'false';
        if (szAutoClose == 'true'){
          // window.showMessageBox(t("SaveToCloud"),t("ConfirmToSaveDataToCloud"),t("Cancel"),t("Confirm"),()=>{
          //   ipcSend('force-close-window');
          // },async ()=>{
          //   setLoad({
          //     spinning:true,
          //     tip:t('Closing')+'...'
          //   })
          //
          //   window.backupDb().then(res=>{
          //     //强制关闭了...
          //     ipcSend('force-close-window');
          //   })
          // })
          if (checkData.isPanNew){
            window.showMessageBox(t("Tips"),t("LocalDataIsOld"),t("Cancel"),t("Confirm"),()=>{
              ipcSend('force-close-window',{dontUpdateTime:true});
            },()=>{
              //不提示直接备份.
              setLoad({
                spinning:true,
                tip:t('Closing')+'...'
              })
              window.backupDb().then(res=>{
                //强制关闭了...
                ipcSend('force-close-window');
              })
            })
          }else{
            //不提示直接备份.
            window.showMessageBox(t("Tips"),t("AreYouSureSaveToCloud"),t("Skip"),t("Save"),()=>{
              //强制关闭了...
              ipcSend('force-close-window');
            },()=>{
              setLoad({
                spinning:true,
                tip:t('Closing')+'...'
              })
              window.backupDb().then(res=>{
                //强制关闭了...
                ipcSend('force-close-window');
              })
            },false)
          }
        }else{
          ipcSend('force-close-window');
        }
      }
    })

    /**
     * 监听PDF注记的修改
     */
    ipcOn('pdf-note-update',async (msg,data)=>{
      //保存注记到库
      //获取这个library的所有注记
      const arrayPdfAnnos = await getLibraryByLibraryId(data.fileId);
      const dbLibary = await getCardById(data.fileId);

      // console.log('pdf-note-update')
      // console.log(data.annotations);

      for (let i=0;i<data.annotations.length;i++){
        const anno = data.annotations[i];
        let dbAnno = arrayPdfAnnos.find(p=>p.id == anno.id);

        //base64转成图片保存
        let szFileName:any;
        let wh:any;
        if (!dbAnno){
          dbAnno = {};
        }

        const pdfAnnoLibrary = {
          ...dbAnno,
          type:'pdfAnno',
          name:dbLibary?.name,
          id:anno.id,
          libraryId:data.fileId,
          comment:anno.comment,
          createTime:dbAnno?.createTime || Date.now(),
          updateTime:Date.now(),
          text:anno.text,
          annoType:anno.type,
          color:anno.color,
        }
        if (anno.type == 'image' && anno.image/*&& !dbAnno.thumbImage*/){//标注区域可以修改？？？？全部重生成好了。。。。
          szFileName = anno.id + '.png';
          if (anno.image.startsWith("data:image")){
            await ipcInvoke('write-base64-image',{fileName:szFileName,imgBase64:anno.image});
            wh = await getBase64ImageSize(anno.image);
          }else{
            wh = await getImageFileWH(anno.image);
          }

          if (wh){
            pdfAnnoLibrary.thumbImage = 'localfile://'+szFileName;
            pdfAnnoLibrary.width = wh?.width;
            pdfAnnoLibrary.height = wh?.height;
          }
        }
        await updateCard(pdfAnnoLibrary);
      }

      //删除数据库中没有的。
      for (let i=0;i<arrayPdfAnnos.length;i++){
        const item = arrayPdfAnnos[i]
        const anno = data.annotations.find(p=>p.id == item.id);
        if (!anno){
          //数据库有 新发来的注册没有--删除
          item.isDeleted = 1;
          item.deleteTime = Date.now();

          await updateCard(item);
        }
      }

      if (data.newId && !global.g_isImportProject){
        window.showMessageTip(t("Highlight saved"),t("Manage tags"),"manageTag",{id:data.newId,buttonTxt1:t("Add a note")});
      }

      //刷新列表
      postMessage(EVENT_REFRESH_LIBRARY_LIST);
      //刷新右侧栏的注记列表，如果有的话---什么情况呢，打开了右侧栏，打开了浮窗，在浮窗里面新建注记，然后又拖动注记到画布，然后又双击画布，这时候右侧栏的注记还没有刷新.所有的之前不考虑的东西都在一点点补充上去。
      if (data.fileId){
        postMessage(EVENT_REFRESH_PDF_HIGHLIGHT,{fileId:data.fileId})
      }

      //刷新content
      if (window.onRefreshContentElement) {
        window.onRefreshContentElement();
      }
    })

    ipcOn('notify-main-library-update',(msg,data)=>{
      window.globalRefreshList('refreshLibraryList_');
    })
    //消息监听--float card
    ipcOn('notify-floatwindow-action',(msg,data)=>{
      if (data.action == 'themeChanged'){
        initThemeData();
        //刷新card
        window.globalRefreshList('updateTheme_notev2_');
      }else if (data.action == 'languageChanged'){
        const szLangCode = data.languageCode;
        switchLanguage(szLangCode);
        //插入一些额外的样式表...
        var style = document.createElement('style');
        document.head.appendChild(style);
        if (style.sheet){
          style.sheet.insertRule(`.ProseMirror-focused p.is-empty::before{content:"${isInSingleFloatWindow()?'':t("InsertBlock")}"}`,0)
          style.sheet.insertRule(`.ProseMirror-focused h1.is-empty::before{content:"${t("H1")}"}`,1)
          style.sheet.insertRule(`.ProseMirror-focused h2.is-empty::before{content:"${t("H2")}"}`,2)
          style.sheet.insertRule(`.ProseMirror-focused h3.is-empty::before{content:"${t("H3")}"}`,3)
        }
        postMessage(EVENT_LANGUAGE_CHANGED);
        if(window.refreshBlockMenuExtends){
          window.refreshBlockMenuExtends();
        }
      }
    })
    //自动恢复关闭窗口时的数据库备份。。如果有的话...
    //这里还是让用户手动触发。。。。
    // ipcInvoke('auto-restore-db').then((arrayBufs:any)=>{
    //   if (arrayBufs){
    //     const blob = new Blob([new Uint8Array(arrayBufs, 0, arrayBufs.length)]);
    //     importDb(blob,(progress:any)=>{
    //       if (progress.completedRows == progress.totalRows){
    //         postMessage(EVENT_NOTE_CHANGED);//刷新card...
    //         postMessage(EVENT_REFRESH_LIBRARY_LIST);//或者list
    //         postMessage(EVENT_FAVIRIATE_CHANGE);//刷新收藏 ...
    //         message.success(t("Sync success"));
    //       }
    //     }).then(res=>{
    //       console.log('auto-restore');
    //       console.log(res);
    //     });
    //   }
    // })

    /////*****非web...
    if (!isWeb()){
      setTimeout(()=>{
        if (!global.g_isRecvOutOpenAppMessage){
          logger('no recv login message "check-outopen-app-url" message replace....')
          ipcInvoke('check-outopen-app-url').then(szArgs=>{
            loginAndCheck(szArgs);
          })
        }
      },600)

      window.startAutoBackup();
    }

    // if (DEBUG){
    //   ipcInvoke("check-args",{filePath:'/Users/liu/Downloads/建筑设计-使用案例ZIP.pcanvasx'}).then(args=>{
    //     if (args != undefined && args.hasOwnProperty("data")){
    //       // global.g_openOutData = {data:args.data,filePath:args.filePath};
    //       //发送消息，如果canvaslist 在，他处理。
    //       window.onNavigateDraw(args.data,args.filePath);
    //     }
    //   })
    // }

    //插入一些额外的样式表...
    var style = document.createElement('style');
    document.head.appendChild(style);
    if (style.sheet){
      style.sheet.insertRule(`.ProseMirror-focused p.is-empty::before{content:"${isInSingleFloatWindow()?'':t("InsertBlock")}"}`,0)
      style.sheet.insertRule(`.ProseMirror-focused h1.is-empty::before{content:"${t("H1")}"}`,1)
      style.sheet.insertRule(`.ProseMirror-focused h2.is-empty::before{content:"${t("H2")}"}`,2)
      style.sheet.insertRule(`.ProseMirror-focused h3.is-empty::before{content:"${t("H3")}"}`,3)
    }

    window.addEventListener('message', windowMessageEvent);
    window.addEventListener('unhandledrejection',windowUnhandledrejection);


    return ()=>{
      unSubscribe(EVENT_SHOW_DIALOG_DRAWINDEX);
      unSubscribe(EVENT_OPEN_LIBRARY_ITEM);
      unSubscribe(EVENT_SHOW_COMMON_INPUT);
      ipcRemoveThisAll('outopenapp-message');
      ipcRemoveThisAll('outfile-read-db-data');
      ipcRemoveThisAll('notify-main-library-update');
      ipcRemoveThisAll('notify-floatwindow-action');
      ipcRemoveThisAll('show-loading-pcanvas')
      window.removeEventListener('message', windowMessageEvent);
      window.removeEventListener('unhandledrejection',windowUnhandledrejection);
    }

  },[])


  useEffect(()=>{
    ipcOn('on-key-pressed',(event,args)=>{
      if (args?.key == KEYS.ESCAPE){
        window.closeProgress();
        postMessage(EVENT_ORIGIN_KEY,{key:args?.key});

        if (window.globalBackspace){
          // window.globalBackspace();
        }

        if (!window.hasDialogShow()){
          window.closeRightSlider();
          if (window.pageDrawIndexEscape){
            window.pageDrawIndexEscape();
          }
        }
        //关闭右侧栏，不管在哪
        // window.closeRightSlider();
      }
    })

    return ()=>{
      ipcRemoveThisAll('on-key-pressed');
    }
  })

  if (window.refreshList == undefined){
    //如果有需要刷新的加进来...
    window.refreshList = {};
  }

  if (window.refreshEditCardList == undefined){
    window.refreshEditCardList = {};
  }

  /**
   * 未处理的异常...
   * @param event
   */
  const windowUnhandledrejection = (event)=>{
    console.log(event);
    //这个跟 日记里面插入网页链接，点击一下打开有什么关系？？？？？？  这种操作后数据库链接就会断开？
    if (event?.reason?.name == "DatabaseClosedError"){
      reOpenDb();
    }
  }

  /**
   * 复制链接...
   * @param event
   */
  const windowMessageEvent = async(event: any) => {
    if (event?.data?.type == 'copy-link'){
      const dbLibrary:any = await getCardById(event.data.data?.highlightId);
      if (dbLibrary){
        createCopyLink('library',dbLibrary.id,'pdfAnno');
      }
    }else if (event?.data?.type == 'drag-annotations'){
      global.g_dragPdfAnno = {};
      global.g_dragPdfAnno.data = event.data.data;
    }else if (event?.data?.type == 'manager-tags'){
      getCardByIds(event.data.data?.highlightIds).then(arrayRes=>{
        if (arrayRes?.length > 0){
          window.showManageTags(arrayRes);
        }
      })
      // getCardById(event.data.data?.highlightId)?.then(res=>{
      //   if(res){
      //     window.showManageTags([res]);
      //   }
      // })
    }else if (event?.data?.type == 'open-url'){
      ipcSend('open-url',event.data.data);
    }else if (event?.data?.type == 'show-info'){
      getCardById(event.data.data?.highlightId)?.then(res=>{
        if(res){
          window.showInfo('library',res);
        }
      })
    }else if (event?.data?.type == 'delete-annotations'){
      const ids = event.data.data.ids;
      window.showMessageBox(t("Tips"),t("SureToDeletePdfAnnos"),t("Cancel"),t("Delete"),null,()=>{
        event.source.postMessage(JSON.stringify({type:'delete-annotations',ids:ids}))
      })
    }else if (event?.data?.type == 'copy-text'){
      // 这里前端已经死了。复制不了数据了。clipboard.write(event.data.data);
      ipcInvoke('copy-text',{text:event.data.data})
      message.info(t('CopiedAllToText'))
    }else if (event?.data?.type == 'add-to-current-board'){
      //添加到当前白板
      const arrayLibrarys = await getCardByIds(event.data.data.highlightIds);
      if (window.onInsertLibraryToCurrentBoard){
        for (let i=0;i<arrayLibrarys.length;i++){
          setTimeout(async ()=>{
            arrayLibrarys[i].pdfId = arrayLibrarys[i].libraryId;
            await window.onInsertLibraryToCurrentBoard(arrayLibrarys[i]);
          },i*100)
        }
      }
    }else if (event?.data?.type == 'add-to-project'){
      //添加到项目
      const arrayLibrarys = await getCardByIds(event.data.data.highlightIds);
      window.showDialogChooseProject(arrayLibrarys);
    }else if (event?.data?.type == 'page-change'){
      //页更改，保存当前页
      getCardById(event.data.fileId).then(res=>{
        if (res){
          res.pageNumber = event.data.pageNumber;
          res.state = event.data.state;
          updateCard(res);
        }
      });
    }
  }

  /**
   * 登录并检测结果
   * @param szArgs
   */
  const loginAndCheck = (szArgs:any)=>{
    if (szArgs){
      const token = getUrlQueryParam(szArgs,'token');
      const szLicenseKey = getUrlQueryParam(szArgs,'license_key');

      localStorage.setItem(ACCESS_TOKEN,token);

      //激活
      window.showProgress(t("CheckingLicenseStatus")+"...");
      if (!isStringNullOrEmpty(szLicenseKey)){
        activeDevice(szLicenseKey);
      }else{
        getUserInfo({},()=>{

        }).then((res)=>{
          window.closeProgress();
          // res.publisherLicense={hasUserLicense:true};
          Global.g_userInfo = res;
          showLicenseMessageTip();
        })
      }
    }
  }

  /**
   * act
   * @param szLic
   */
  const activeDevice = (szLic:string)=>{
    deviceActive(szLic,(error:any)=>{
      if (error.response.status === 404){
        postMessage(EVENT_LICENSE_ACTIVE_TIPS);
      }
    }).then(res=>{
      message.destroy();
      message.info(t("License activated"));
      // console.log(res);
      //再次获取用户信息
      getUserInfo({},()=>{

      }).then((res)=>{
        window.closeProgress();
        // res.publisherLicense={hasUserLicense:true};
        Global.g_userInfo = res;
        showLicenseMessageTip();
      })
    })
  }

  /**
   * 显示license提示并刷新首页
   */
  const showLicenseMessageTip = ()=>{
    if (mIsShowTips)return;

    mIsShowTips = true;
    setTimeout(()=>{
      mIsShowTips = false;
    },1000);

    message.destroy();
    if (hasLicense() || hasDesktopBaseLicense()){
      message.info(t("LicenseActEnjoy"))
    }else{
      message.info(t("Free account activated"))
    }
    postMessage(EVENT_REFRESH_LOGIN_STATUS)
  }

  /**
   * 全局刷新列表，如果有的话....
   */
  window.globalRefreshList = (szRefreshHeader:any,data:any,extra:any)=>{
    if (szRefreshHeader){
      Object.keys(window.refreshList).forEach((key)=>{
        if (key.includes(szRefreshHeader)){
          window.refreshList[key](data,extra);
        }
      })
    }else{
      //刷新别的地方的数据，如果有的话.
      Object.values(window.refreshList).forEach((callback:any)=>{
        callback(data,extra);
      })
    }
  }

  /**
   * 开启全局进度条
   * @param szTip
   */
  window.showIndicator = (szTip = '')=>{
    setLoadSpin({
      spinning: true,
      tip:t(szTip)
    })
  }
  //关闭全局进度条
  window.closeIndicator = ()=>{
    setLoadSpin({
      spinning: false,
      tip:''
    })
  }

  window.messageInfo = (szMsg:any)=>{
    message.info(szMsg);
  }

  window.messageInfoT = (szMsg)=>{
    message.info(t(szMsg));
  }

  window.messageError = (szMsg:any)=>{
    message.error(t(szMsg))
  }

  /**
   * 显示一个tips,可操作
   * @param szMsg
   * @param szButtonTxt
   * @param szAction
   * @param data
   */
  window.showMessageTip = (szMsg,szButtonTxt,szAction,data)=>{
    setTipsInfo({
      message:szMsg,
      buttonTxt:szButtonTxt,
      action:szAction,
      data
    });

    setTimeout(()=>{
      setTipsInfo(null);
    },4000);
  }
  window.closeMessageTip = ()=>{
    setTipsInfo(null);
  }

  /**
   * 显示消息窗口
   * @param title
   * @param content
   * @param cancelText
   * @param okText
   * @param cancelCallback
   * @param callback
   */
  window.showMessageBox = (title:string,content:string,cancelText:string,okText:string,cancelCallback:any,callback:any,maskCloseable:any)=>{
    dialogMessageBoxRef.current?.onShowDialogOkCancel(title,content,cancelText,okText,cancelCallback,callback,maskCloseable);
  }
  window.closeMessageBox = ()=>{
    dialogMessageBoxRef.current?.onCloseDialog();
  }
  window.showMessageBoxTips = (title:string,content:string,okText:string)=>{
    dialogMessageBoxRef.current?.onShowDialogOkCancel(title,content,'',okText,null,null);
  }
  /**
   * 显示pdf预览
   * @param showName
   * @param fileId
   * @param fileName
   * @param isFullScreen
   * @param isViewAllHighlight

  window.showPdfPreview = (showName:string,fileId:string,fileName:string,isFullScreen:boolean=false,isViewAllHighlight:boolean=false,isShowMoreMenu = true,extra=null)=>{

    let szFilePath = localStorage.getItem(KEY_FILE_DIR)+fileName;
    if (isAbsoluteFilePath(fileName)){
      szFilePath = fileName;
    }
    ipcInvoke('read-file-absolute-path',{filePath:szFilePath}).then(res=>{
      const blob = new Blob([res]);
      const url = URL.createObjectURL(blob);
      let highlightId = '';
      if (extra){
        if (extra.highlightId){
          highlightId = extra.highlightId;
        }
      }
      setFileState({
        open: true,
        fileName: showName??getFileName(fileName),
        filePath: url,
        fileId: fileId,
        isFullScreen: isFullScreen,
        isViewAllHighlight: isViewAllHighlight,
        isShowMoreMenu: true,
        highlightId:highlightId
      })
    })
  }
*/

  /**
   * 显示一个消息提示，带view点击
   * @param szTips
   * @param callback
   */
  window.onShowMessageTip = (szTips:string,callback:any)=>{
    setIsShowMessageTipInfo(true);
    setTimeout(()=>{
      messageTipRef.current?.onShowMessage(szTips,callback);
    },100);
  }

  /**
   * 开启进度条...
   * @param szTips
   */
  window.showProgress = (szTips:string = t("Uploading"),direction:any,isMaskClose = true)=>{
    dialogProgressRef.current?.onShowDialog(szTips,direction,isMaskClose);
  }
  window.updateProgress = (szTips:string)=>{
    dialogProgressRef.current?.onUpdateProgress(szTips);
  }
  window.onProgressFinished = (szTips:string)=>{
    dialogProgressRef.current?.onFinished(szTips);
  }
  window.closeProgress = ()=>{
    dialogProgressRef.current?.onCloseDialog();
  }

  window.showProgress1 = (szTips:any,direction:any,isMaskClose = true)=>{
    dialogProgressRef1.current?.onShowDialog(szTips,direction,isMaskClose);
  }
  window.closeProgress1 = ()=>{
    dialogProgressRef1.current?.onCloseDialog();
  }


  window.showInfo = (szType:string|'project'|'library',data:any)=>{
    setIsShowDialogInfos(true);
    setTimeout(()=>{
      dialogInfosRef.current?.onShowDialog(szType,data)
    },100);
  }

  window.closeInfo = ()=>{
    setIsShowDialogInfos(false);
  }

  //library,project标签管理窗口
  window.showManageTags = (arraySelectItem:any,callback)=>{
    dialogTagManagerRef.current?.onShowDialog(arraySelectItem,callback);
  }

  /**
   * 显示card中的链接弹窗
   */
  window.showDialogCardLink = (link:any,onCallback:any)=>{
    dialogCardLinkPageRef.current?.onShowLink(link,onCallback);
  }

  /**
   * 导入库----video,pdf,image,audio=====
   * @param type
   */
  window.showDialogLibraryImport = (szType:any,callback:any)=>{
    setIsShowDialogLibraryImport(true);
    setTimeout(()=>{
      dialogLibraryImport.current?.onShowDialog(szType,callback)
    },100);
  }
  window.closeDialogLibraryImport = ()=>{
    setIsShowDialogLibraryImport(false);
  }

  /**
   * 导入Weblink
   * @param type
   */
  window.showDialogWeblinkImport = (callback:any)=>{
      setIsShowDialogWeblinkImport(true);
      setTimeout(()=>{
          dialogWeblinkImport.current?.onShowDialog(callback)
      },100);
  }
  window.closeDialogWeblinkImport = ()=>{
    setIsShowDialogWeblinkImport(false);
  }

  /**
   * 全局搜索
   * @param type
   */
  window.showDialogGlobalSearch = ()=>{
    setIsShowDialogGlobalSearch(true);
    setTimeout(()=>{
      dialogGlobalSearchRef.current?.onShowDialog()
    },100);
  }
  window.closeDialogGlobalSearch = ()=>{
    if (window.isGlobalSearchPin && window.isGlobalSearchPin()){
      return;//置顶的，不要关闭....
    }
    setIsShowDialogGlobalSearch(false);
  }

  /**
   * 显示card中的插入cardlist弹窗
   * @param editor
   */
  window.showPopupCardList = (editor:any,isFromAt=true)=>{
    global.g_showDialogs.dialogInfos = true;
    mIsPopupCardListFromAt.current = isFromAt;
    editorRef.current = editor;
    setIsShowCardList(true);
    // const selection = window.getSelection();
    // if (selection.rangeCount) {
    //   const range = selection.getRangeAt(0);
    //   const rect = range.getBoundingClientRect();
    //   // 返回光标相对于编辑器容器的位置
    //   setLinkPosition({
    //     left: rect.left+'px',
    //     top:rect.top+'px'
    //   })
    // }
    let nHeight = document.body.clientHeight;
    let nWidth = document.body.clientWidth;

    const pos = getSelectionCoords(window);
    pos.y += 30;
    if (pos.y + 300 > nHeight){
      pos.y -= 300;
    }
    //右边距
    const nW = 480 + pos.x;
    if (nW > nWidth){
      pos.x = nWidth - 480;
    }

    console.log(pos)
    setLinkPosition({
      left:pos.x+'px',
      top:pos.y + 'px'
    })
  }
  /**
   * 关闭cardlist弹窗
   */
  window.closePopupCardList = ()=>{
    // global.g_openDialogs = false;
    setIsShowCardList(false);
    return isShowCardList;
  }

  /**
   * 显示公式弹窗
   * @param editor
   */
  window.showPopupLatexBlock = (props:any,x,y,szDefaultLatexBlockContent:any,onChange:any)=>{
    mLatexBlockOnChange = onChange;
    latexBlockProps.current = props;
    mEditor = props.editor;
    setIsShowLatexBlock(true);
    mszDefaultLatexBlockContent = (szDefaultLatexBlockContent);
    let nHeight = document.body.clientHeight;

    const pos = {x,y};
    // if (pos.y + 300 > nHeight){
    //   pos.y -= 300;
    // }
    setLinkPosition({
      left:pos.x+'px',
      top:pos.y + 'px'
    })
  }

  window.closePopupLatexBlock = ()=>{
    setIsShowLatexBlock(false);
  }

  /**
   * 显示通用输入框
   * @param name
   * @param title
   * @param placeHolder
   * @param callback
   */
  window.showCommonInput = (name,title,placeHolder,cancelText,okText,callback)=>{
    dialogInputRef.current?.onShowDialogAll(name,title,cancelText,okText,(szContent:any)=>{
      callback(szContent)
    },placeHolder || '')
  }
  /**
   * 关闭通用的输入对话框
   */
  window.closeCommonInput = ()=>{
    dialogInputRef.current?.onCloseDialog();
  }

  /**
   * 显示视频笔记
   */
  // window.showVideoNotes = (highlight:any,selectedId:any=null,type:any)=> {
  //   setIsShowVideoPreview(true);
  //   setTimeout(() => {
  //     let szElementType = "embeddable";
  //     if (highlight.type == 'video' || highlight.type == 'audio') {
  //       szElementType = 'iframe';
  //     }
  //     const element = {
  //       id: highlight.id,
  //       type: szElementType,
  //       customData: {
  //         generationData: {
  //           type: 'file',
  //           id: highlight.libraryId,
  //           name: highlight.name,
  //           fileName: highlight.fileName
  //         }
  //       },
  //       link: highlight.url || highlight.fileName,
  //       src: highlight.url || highlight.fileName,
  //       videoNotes: highlight.data,
  //       selectedId: selectedId
  //     }
  //     //保存这个元素的笔记到缓存....
  //     videoCache.set(highlight.id, highlight.data);
  //     setVideoNotes({
  //       visibility: true,
  //       type: type || 'model',
  //       element: element,
  //     })
  //   }, 150)
  // }
  // window.closeVideoNotes = ()=>{
  //   setIsShowVideoPreview(false);
  // }
  /**
   * 显示高亮导入
   */
  window.showDialogImportHighlight = (callback:any)=>{
    setIsShowDialogImportHighlight(true);
    setTimeout(()=>{
      dialogImportHighlightRef.current?.onShowDialog(callback);
    },100)
  }

  window.closeDialogImportHighlight = ()=>{
    dialogImportHighlightRef.current?.onCloseDialog();
  }


  /**
   * 显示翻译导入
   */
  window.showDialogImportTranscript = (callback:any)=>{
    setIsShowDialogImportTranscript(true);
    setTimeout(()=>{
      dialogImportTranscriptRef.current?.onShowDialog(callback);
    },100)
  }

  window.closeDialogImportTranscript = ()=>{
    setIsShowDialogImportTranscript(false);
  }


  /**
   * 显示添加到项目对话框
   */
  window.showDialogChooseProject = (arraySelectItem:any,szTitle:any,from:any,callback:any)=>{
    setIsShowDialogChooseProject(true);
    setTimeout(()=>{
      dialogChooseProjectRef.current?.onShowDialog(arraySelectItem,szTitle,from,callback);
    },100)
  }

  /**
   * 卡片的历史记录
   * @param szCardId
   */
  window.showDialogCardHistory = (szCardId:any,callback:any)=>{
    setIsShowCardHistory(true);
    setTimeout(()=>{
      dialogCardHistoryRef.current?.onShowDialog(szCardId,callback);
    },100)
  }
  window.closeDialogCardHistory = ()=>{
    setIsShowCardHistory(false);
    // dialogCardHistoryRef.current?.onCloseDialog();
  }


  /**
   * 项目的历史记录
   * @param szProjectId
   */
  window.showDialogProjectHistory = (szProjectId:any,callback:any)=>{
    setIsShowProjectHistory(true);
    setTimeout(()=>{
      dialogProjectHistoryRef.current?.onShowDialog(szProjectId,callback);
    },100)
  }
  window.closeDialogProjectHistory = ()=>{
    setIsShowProjectHistory(false);
    // dialogCardHistoryRef.current?.onCloseDialog();
  }

  /**
   * 导入文件进度框
   */
  window.showDialogFileImportLoading = (szImportMode:any)=>{
    setIsShowFileImportLoading(true);
    mShowImportFileProgressTime = Date.now();
    setTimeout(()=>{
      dialogFileImportLoadingRef.current?.onShowDialog(szImportMode);
    },100)
  }
  window.closeDialogFileImportLoading = ()=>{
    const nSub = Date.now() - mShowImportFileProgressTime;
    if (nSub < 1000){
      setTimeout(()=>{
        dialogFileImportLoadingRef.current?.onCloseDialog();
      },(1000 - nSub))
    }else{
      dialogFileImportLoadingRef.current?.onCloseDialog();
    }
  }

  /**
   * 拖拽文件导入的对话框提示.
   */
  window.showDialogFileImportDrag = (callback)=>{
    setIsShowDialogFileImportModeDrag(true);
    setTimeout(()=>{
      dialogDragFileImportModeRef.current?.onShowDialog(callback);
    },100)
  }
  window.closeDialogFileImportDrag = ()=>{
    setIsShowDialogFileImportModeDrag(false);
    dialogDragFileImportModeRef.current?.onCloseDialog();
  }

  /**
   * 打开右侧栏
   */
  window.openRightSlider = (data:any,type:any,extra:any)=>{
    rightSliderRef.current?.onOpenSlider(data,type,extra);
  }
  window.closeRightSlider = ()=>{
    rightSliderRef.current?.onCloseSlider();
  }

  /**
   * 显示图片/视频查看
   * @param data
   */
  // window.showDialogMediaView = (data)=>{
  //   setIsShowDialogMediaView(true);
  //   setTimeout(()=>{
  //     dialogMediaViewRef.current?.onShowDialog(data);
  //   },100)
  // }
  // window.closeDialogMediaView = ()=>{
  //   setIsShowDialogMediaView(false)
  // }

  /**
   * 显示注记对话框
   * @param data
   */
  window.showDialogPdfAnno = (data)=>{
    setIsShowDialogPdfAnno(true);
    setTimeout(()=>{
      dialogPdfAnnoRef.current?.onShowDialog(data);
    },100)
  }
  window.closeDialogPdfAnno = ()=>{
    setIsShowDialogPdfAnno(false);
  }

  /**
   * 显示视频注记
   * @param data
   */
  window.showDialogVideoAnno = (data)=>{
    setIsShowDialogVideoAnno(true);
    setTimeout(()=>{
      dialogVideoAnnoRef.current?.onShowDialog(data);
    },100)
  }
  window.closeDialogVideoAnno = ()=>{
    setIsShowDialogVideoAnno(false)
  }

  /**
   * 显示链接
   * @param link
   * @param from
   * @param callback
   */
  window.showDialogLink = (link:any,from:any,callback:any,extra:any)=>{
    setIsShowDialogLink(true);
    mDialogLinkCallback = callback;
    setTimeout(()=>{
      dialogLinkRef.current?.onShowDialog(link,from,extra);
    },100)
  }

  /**
   * 显示图片预览
   * @param szSrc
   */
  window.showImagePreview = (szSrc:any)=>{
    setImagePreviewInfo({
      visible: true,
      src:getLocalFilePath(szSrc,true)
    })
  }

  /**
   * 显示图片预览
   * @param szSrc
   */
  window.showImagePreviewWithFullUrl = (szSrc:any)=>{
    setImagePreviewInfo({
      visible: true,
      src:szSrc
    })
  }

  /**
   * 选择文件弹窗
   * @param szAcceptExt
   */
  window.showFileSelect = (szAcceptExt:string,callback:any)=>{
    setFileAcceptExt(szAcceptExt);
    mFileSelectCallback = callback;
    //是否需要选择...
    mImportMode = localStorage.getItem(KEY_FILE_IMPORT_MODE) || IMPORT_FILE_MODE_ASKME;
    if (mImportMode == IMPORT_FILE_MODE_ASKME){
      window.showDialogFileImportDrag((szImportMode:any)=>{
        mImportMode = szImportMode;
        fileSelectRef.current?.click();
      })
    }else{
      setTimeout(()=>{
        fileSelectRef.current?.click();
      },100)
    }
  }

  /**
   * 显示选择图片对话框
   */
  window.showDialogChooseImage = (callback:any)=>{
    setIsShowDialogChooseImage(true);
    mFileSelectCallback = callback;
    setFileAcceptExt(getImageExt());
    setTimeout(()=>{
      dialogChooseImageRef.current?.onShowDialog();
    },160)
  }
  window.closeDialogChooseImage = ()=>{
    mFileSelectCallback = null;
    setFileAcceptExt("*");
    setIsShowDialogChooseImage(false);
  }

  /**
   * 显示mindmap的链接模式
   * @param callback
   */
  window.showDialogMindmapLinkMode = (callback:any)=>{
    setIsShowDialogMindmapLinkMode(true);
    setTimeout(()=>{
      dialogMindmapLinkModeRef.current?.onShowDialog(callback);
    },100);
  }

  /**
   * 显示mindmap全局配置
   */
  window.showDialogMindmapStyleSetting = (element:any)=>{
    setIsShowDialogMindmapStyleSetting(true);
    setTimeout(()=>{
      dialogMindmapStyleSettingRef.current?.onShowDialog(element);
    },100);
  }

  /**
   * 显示类型配置...
   */
  window.showDialogTypeSwitcherSetting = (callback:any)=>{
    setIsShowDialogTypeSwitcherSetting(true);
    setTimeout(()=>{
      dialogTypeSwitcherSettingRef.current?.onShowDialog(callback);
    })
  }
  window.closeDialogTypeSwitcherSetting = ()=>{
    setIsShowDialogTypeSwitcherSetting(false);
  }

  /**
   * 显示添加pdf或者card或者file的弹窗
   * @param callback
   * @param type
   */
  window.showDialogChooseCardPdf = (callback:any,type:any)=>{
    setIsShowDialogChooseCardPdf(true);
    mDialogChooseCardPdfCallback = callback;
    setTimeout(()=>{
      dialogChooseCardPdfRef.current?.onShowDialog(null,type);
    },100);
  }
  window.closeDialogChooseCardPdf = ()=>{
    setIsShowDialogChooseCardPdf(false);
    mDialogChooseCardPdfCallback = null;
  }

  /**
   * 自动关闭那个小的输入 note的弹窗.....
   */
  window.closeAddNoteWindow = ()=>{
    setShowAddANoteData(null);
  }

  /**
   * 移除card中的highlight
   * @param card
   * @param highlight
   */
  window.removeCardHighlight = async (highlight:any,callback:any)=>{
    await simpleEditorRef.current?.onRemoveHighlight(highlight,callback)
  }
  /**
   * 更新card的评论--备注
   * @param highlight
   * @param callback
   */
  window.onUpdateComment = async (highlight:any,callback:any)=>{
    await simpleEditorRef.current?.onUpdateComment(highlight,callback);
  }

  /**
   * 自动备份
   */
  window.startAutoBackup = ()=>{
    mAutoBackupTimer = setTimeout(async()=>{
      if (localStorage.getItem(KEY_ENABLE_AUTO_BACKUP) != 'false'){
        const nLastTime = getIntValueFromLocalStrage(KEY_LAST_BACKUP_TIME);
        const nInterval = Date.now() - nLastTime;

          let autoBackupTime:any = localStorage.getItem(KEY_AUTO_BACKUP_INTERVAL) || (DB_AUTO_BACKUP_TIME+'');
          autoBackupTime = getSafeInt(autoBackupTime);
          if (isNaN(autoBackupTime) || autoBackupTime < 60*60*1000){
              //自动备份时间小于1小时的话。。。自动设置为6小时...
              autoBackupTime = DB_AUTO_BACKUP_TIME;
          }

          if (nInterval > autoBackupTime){
          const blobDb = await exportDb((progress: any) => {
            // const fProgress = (progress.completedRows / progress.totalRows) / 2;
            // console.log('export progress,'+fProgress)
          });

          var reader = new FileReader();
          reader.onload = function (result) {
            const fileName = localStorage.getItem(KEY_AUTO_BACKUP_PATH)+'Noteey_AutoBackup'+formatDate(Date.now(),'yyyyMMddhhmmss')+'.db'
            ipcInvoke('backup', {
              filePath:'',
              fileName: fileName,
              stream: result.target.result,
              arrayFiles: []
            }).then(res=>{
              window.startAutoBackup();
              //记录上次的备份时间
              localStorage.setItem(KEY_LAST_BACKUP_TIME,Date.now()+'');
            }).catch(err=>{
              // window.startAutoBackup();
              logger('auto backup fail---\n'+err);
            })
          }
          reader.readAsArrayBuffer(blobDb);
        }else{
          window.startAutoBackup();
        }
      }
    },2*60*1000);
  }
  window.stopAutoBackup = ()=>{
    clearTimeout(mAutoBackupTimer);
  }

  /**
   * web端不支持的离线版本...
   */
  window.showTipNotSupportWebOfflineVersion = ()=>{
    window.showMessageBox(t("Tips"),t("WebOfflineNotSupport"),t("Cancel"),t("DownloadDesktop"),null,()=>{
      if (isZh()){
        ipcSend('open-url',import.meta.env.VITE_HTTP_HOME_ZH);
      }else{
        ipcSend('open-url',import.meta.env.VITE_HTTP_HOME);
      }
    })
  }

  /**
   * 在pin的对话框数量
   */
  window.getDialogPinCount = ()=>{
    let nCount = 0;
    for (let i=0;i<dialogCardRefs.current.length;i++) {
      const cardRef = dialogCardRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()) {
        nCount ++;
      }
    }

    for (let i=0;i<dialogPdfRefs.current.length;i++) {
      const cardRef = dialogPdfRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()) {
        nCount++;
      }
    }

    for (let i=0;i<dialogVideoRefs.current.length;i++) {
      const ref = dialogVideoRefs.current[i];
      //如果未置顶，则关闭
      if (ref.getIsPin()) {
        nCount++;
      }
    }

    for (let i=0;i<dialogMediaRefs.current.length;i++) {
      const ref = dialogMediaRefs.current[i];
      //如果未置顶，则关闭
      if (ref.getIsPin()) {
        nCount++;
      }
    }

    //全局的搜索...
    if (window.isGlobalSearchPin){
      if (window.isGlobalSearchPin()){
        nCount++;
      }
    }


    return nCount;
  }

  window.showOrHiddenAllFloatWin = ()=>{
    window.showOrHiddenFloatCardWindow();
    window.showOrHiddenFloatPdfWindow();
    window.showOrHiddenFloatVideoWindow();
    window.showOrHiddenFloatMediaWindow();
    window.showOrHiddenFloatTiptapTextEditorWindow();
  }

  /**
   * 取消所有隐藏的.
   */
  window.visibleAllFloatWin = ()=>{
    message.info(t('ExistFloatMode'))
    global.g_isHiddenAllFloatWin = false;
    window.showOrHiddenAllFloatWin();
  }

  /**
   * 当前所有浮窗的数量
   */
  window.getPinCount = ()=>{
    return window.getCardPinCount() + window.getPdfPinCount() + window.getVideoPinCount() + window.getMediaPinCount() + window.getTiptapTextEditorPinCount();
  }

  /**
   * 卡片弹窗数量
   */
  window.getDialogCardCount = ()=>{
    return arrayDialogCards.length;
  }


  //region****************************多card弹窗****************************/
  window.cardUpdateCallbacks = {};//这里记录所有的card更新时别的窗口需要更新的回调....

  window.showDialogCard = (data:any)=>{
    window.openDialogCard(data);
  }
  /**
   * 打开卡片弹窗
   */
  window.openDialogCard = (data:any)=>{
    if (global.g_showDialogs['settingIndex']){
      return;
    }
    if (!data)return;
    
    if (isInSidebar()){
      window.parent.openDialogCard(data);
      return;
    }
    dialogCardRefs.current = [];
    const arrayCards = [...arrayDialogCards];
    if (!arrayCards.some(p=>p.id == data.id)){
      //同一个，不能再加进来
      arrayCards.push(data);
    }else{
      setTimeout(()=>{
        const div = document.getElementById('card-dialog-'+data.id);
        if (div) {
          mDialogZIndex += 2;
          div.style.zIndex = mDialogZIndex + '';
        }
      },100)
    }
    setArrayDialogCards(arrayCards);
  }

  /**
   * 关闭一个卡片窗口
   * @param data
   */
  window.closeDialogCard = (data:any)=>{
    setShowAddANoteData(null);
    if (!data)return;
    const arrayCards = [...arrayDialogCards];
    for (let i=0;i<arrayCards.length;i++){
      if (arrayCards[i].id == data.id){
        arrayCards.splice(i,1);
        dialogCardRefs.current = [];
        setArrayDialogCards(arrayCards);
        break;
      }
    }
  }

  //显示或隐藏卡片浮窗----
  window.showOrHiddenFloatCardWindow = ()=>{
    for (let i=0;i<dialogCardRefs.current.length;i++){
      const cardRef = dialogCardRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()){
        cardRef.showOrHidden();
      }
    }
  }

  /**
   * 关闭未置顶的窗口
   */
  window.closeUnpinDialogCard = ()=>{
    if (arrayDialogCards.length == 0)return;
    const arrayCards = [...arrayDialogCards];
    for (let i=0;i<dialogCardRefs.current.length;i++){
      const cardRef = dialogCardRefs.current[i];
      //如果未置顶，则关闭
      if (!cardRef.getIsPin()){
        const data = cardRef.getData();
        const nIndex = arrayCards.findIndex(p=>p.id == data.id);
        if (nIndex != -1){
          arrayCards.splice(nIndex,1);
        }
      }
    }
    dialogCardRefs.current = [];
    setArrayDialogCards(arrayCards);
  }

  /**
   * 将card置于顶层
   * @param data
   */
  window.bringCardDialogFront = (data:any)=>{
    if (!data)return;
    const div = document.getElementById('card-dialog-'+data.id);
    if (div) {
      mDialogZIndex++;
      div.style.zIndex = mDialogZIndex + '';
    }
  }
  /**
   * 打开的对话框数量
   */
  window.getDialogCardsCount = ()=>{
    return arrayDialogCards.length;
  }

  /**
   * 当前浮窗的card数量
   */
  window.getCardPinCount = ()=>{
    let nPinCount = 0;
    for (let i=0;i<dialogCardRefs.current.length;i++) {
      const cardRef = dialogCardRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()) {
        nPinCount ++;
      }
    }
    return nPinCount;
  }

  //endregion****************************多card弹窗 end****************************/


  //region****************************多pdf弹窗****************************/

  /**
   * 显示pdf预览
   * @param showName
   * @param fileId
   * @param fileName
   * @param isFullScreen
   * @param isViewAllHighlight
   */
  window.showPdfPreview = async (showName:string,fileId:string,fileName:string,isFullScreen:boolean=false,isViewAllHighlight:boolean=false,isShowMoreMenu = true,extra=null)=>{
    if (isInSidebar()){
      window.parent.showPdfPreview(showName,fileId,fileName,isFullScreen,isViewAllHighlight,isShowMoreMenu,extra);
      return;
    }

    const arrayPdfs = [...arrayDialogPdfs];
    let pdfItem = arrayPdfs.find(p=>p.fileId == fileId);
    if (pdfItem){
      pdfItem.open = true;
    }else{
      let szUrl = '';
      if (fileName.startsWith('blob:')){
        szUrl = fileName;
      }else{
        const szFileDir = localStorage.getItem(KEY_FILE_DIR);
        let szFilePath = szFileDir+fileName.replace(szFileDir,'');
        if (isAbsoluteFilePath(fileName)){
          szFilePath = fileName;
        }
        const res = await ipcInvoke('read-file-absolute-path',{filePath:szFilePath});
        const blob = new Blob([res],{type:'application/pdf'});
        szUrl = URL.createObjectURL(blob);
      }

      let highlightId = '';
      if (extra){
        if (extra.highlightId){
          highlightId = extra.highlightId;
        }
      }

      //调用太多了，新加的，数据库重新获取一遍
      const library = await getCardById(fileId);
      let initialPage = library?.pageNumber || 1;
      pdfItem = {
        open: true,
        fileName: showName??getFileName(fileName),
        filePath: szUrl,
        fileId: fileId,
        initialPage:initialPage,
        isFullScreen: isFullScreen,
        isViewAllHighlight: isViewAllHighlight,
        isShowMoreMenu: true,
        highlightId:highlightId,
        state:library?.state
      }
      arrayPdfs.push(pdfItem);
    }

    dialogPdfRefs.current = [];
    pdfItem.zIndex = ++mDialogZIndex;
    pdfItem.maskLayer = (window.getDialogPinCount() == 0);
    // setFileState(pdfItem);
    setArrayDialogPdfs(arrayPdfs);

    /*
    const szFileDir = localStorage.getItem(KEY_FILE_DIR);
    let szFilePath = szFileDir+fileName.replace(szFileDir,'');
    if (isAbsoluteFilePath(fileName)){
      szFilePath = fileName;
    }
    ipcInvoke('read-file-absolute-path',{filePath:szFilePath}).then(res=>{
      const blob = new Blob([res]);
      const url = URL.createObjectURL(blob);
      let highlightId = '';
      if (extra){
        if (extra.highlightId){
          highlightId = extra.highlightId;
        }
      }
      const arrayPdfs = [...arrayDialogPdfs];

      let pdfItem = arrayPdfs.find(p=>p.fileId == fileId);
      if (!pdfItem){
        pdfItem = {
          open: true,
          fileName: showName??getFileName(fileName),
          filePath: url,
          fileId: fileId,
          isFullScreen: isFullScreen,
          isViewAllHighlight: isViewAllHighlight,
          isShowMoreMenu: true,
          highlightId:highlightId,
        }
        arrayPdfs.push(pdfItem);
      }

      pdfItem.zIndex = ++mDialogZIndex;
      // setFileState(pdfItem);
      setArrayDialogPdfs(arrayPdfs);
    })
     */
  }
  /**
   * 关闭一个PDF预览窗口
   * @param pdfItem
   */
  window.closePdfPreview = (pdfItem:any)=>{
    setShowAddANoteData(null);

    const arrayPdfs = [...arrayDialogPdfs];
    // const nIndex = arrayPdfs.findIndex(p=>p.fileId == pdfItem.fileId);
    // if (nIndex != -1){
    //   arrayPdfs.splice(nIndex,1);
    // }
    const arrayPdfItems = arrayPdfs.filter(p=>p.fileId == pdfItem.fileId);
    arrayPdfItems.forEach(p=>p.open = false);

    dialogPdfRefs.current = [];

    if (arrayPdfs.some(p=>p.open)){
      setArrayDialogPdfs(arrayPdfs);
    }else{
      setArrayDialogPdfs([]);
      arrayPdfs.forEach(p=>{
        revokeBlobObjectURL(p.filePath);
      })
    }
  }

  /**
   * pdf对话框置于顶层
   * @param pdfItem
   */
  window.bringDialogPdfFront = (pdfItem:any)=>{
    const arrayPdfs = [...arrayDialogPdfs];
    const firstItem = arrayPdfs.find(p=>p.fileId == pdfItem.fileId);
    if (firstItem){
      firstItem.zIndex = ++mDialogZIndex;
    }
    dialogPdfRefs.current = [];
    setArrayDialogPdfs(arrayPdfs);
  }

  /**
   * 关闭未置顶的窗口
   */
  window.closeUnpinDialogPdf = ()=>{
    if (arrayDialogPdfs.length == 0)return;
    const arrayPdfs = [...arrayDialogPdfs];
    for (let i=0;i<dialogPdfRefs.current.length;i++){
      const cardRef = dialogPdfRefs.current[i];
      //如果未置顶，则关闭
      if (!cardRef.getIsPin()){
        const data = cardRef.getData();
        const nIndex = arrayPdfs.findIndex(p=>p.fileId == data.fileId);
        if (nIndex != -1){
          arrayPdfs.splice(nIndex,1);
        }
      }
    }
    // global.g_showDialogs['dialogPdf'] = (arrayPdfs.length > 0);
    dialogPdfRefs.current = [];
    setArrayDialogPdfs(arrayPdfs);
  }

  //显示或隐藏PDF浮窗----
  window.showOrHiddenFloatPdfWindow = ()=>{
    for (let i=0;i<dialogPdfRefs.current.length;i++){
      const cardRef = dialogPdfRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()){
        cardRef.showOrHidden();
      }
    }
  }

  window.getDialogPdfsCount = ()=>{
    return arrayDialogPdfs.length;
  }

  /**
   * 当前浮窗的pdf数量
   */
  window.getPdfPinCount = ()=>{
    let nPinCount = 0;
    for (let i=0;i<dialogPdfRefs.current.length;i++) {
      const cardRef = dialogPdfRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()) {
        nPinCount ++;
      }
    }
    return nPinCount;
  }

  //endregion****************************多pdf弹窗 ***************************end */


  //region****************************多video弹窗****************************/
  window.showVideoNotesWithElement = async (element:any,isFullScreen)=>{
    if (isInSidebar()){
      window.parent.showVideoNotesWithElement(element,isFullScreen);
      return;
    };
    var arrayDatas = [...arrayDialogVideos];
    let library = await getCardById(element.id);
    if (!library){
      //这里就很奇怪了，本地视频，文件删了，然后通过changesource 变成了在线视频...
      if (element.customData?.generationData?.id){
        library = await getCardById(element.customData?.generationData?.id);
      }
    }

    if (library){
      if (!element.customData){
        element.customData = {};
        element.customData.generationData = {...library}
      }
    }
    let videoNote = arrayDatas.find(p=>p.id == element.id);
    if (videoNote){
      videoNote.visibility = true;
    }else{
      videoNote = {
        visibility: true,
        type: isFullScreen?'fullScreen':'model',
        element: element,
        zIndex:0,
        id:element.id
      };

      arrayDatas.push(videoNote);
    }

    // videoCache.set(element.id, element.data);
    videoNote.zIndex = ++mDialogZIndex;
    dialogVideoRefs.current = [];

    setArrayDialogVideos(arrayDatas);
  }
  /**
   * 显示视频笔记
   */
  window.showVideoNotes = (highlight:any,selectedId:any=null,type:any)=> {
    if (isInSidebar()){
      window.parent.showVideoNotes(highlight,selectedId,type);
      return;
    };

    var arrayDatas = [...arrayDialogVideos];
    //先找一下，原来有的话直接显示
    let videoNote = arrayDatas.find(p=>p.id == highlight.id);
    if (videoNote){
      videoNote.visibility = true;
    }else{
      let szElementType = "embeddable";
      if (highlight.type == 'video' || highlight.type == 'audio') {
        szElementType = 'iframe';
      }
      const element = {
        id: highlight.id,
        type: szElementType,
        customData: {
          generationData: {
            type: 'file',
            id: highlight.libraryId || highlight.id ,
            name: highlight.name,
            fileName: highlight.fileName
          }
        },
        link: highlight.url || highlight.fileName,
        src: highlight.url || highlight.fileName,
        videoNotes: highlight.data,
        selectedId: selectedId
      }
      //保存这个元素的笔记到缓存....
      videoCache.set(highlight.id, highlight.data);
      videoNote = {
        visibility: true,
        type: type || 'model',
        element: element,
        zIndex:0,
        id:highlight.id,
      };
      arrayDatas.push(videoNote);
    }
    videoNote.zIndex = ++mDialogZIndex;
    dialogVideoRefs.current = [];

    setArrayDialogVideos(arrayDatas);

    /*
    setIsShowVideoPreview(true);
    setTimeout(() => {
      let szElementType = "embeddable";
      if (highlight.type == 'video' || highlight.type == 'audio') {
        szElementType = 'iframe';
      }
      const element = {
        id: highlight.id,
        type: szElementType,
        customData: {
          generationData: {
            type: 'file',
            id: highlight.libraryId,
            name: highlight.name,
            fileName: highlight.fileName
          }
        },
        link: highlight.url || highlight.fileName,
        src: highlight.url || highlight.fileName,
        videoNotes: highlight.data,
        selectedId: selectedId
      }
      //保存这个元素的笔记到缓存....
      videoCache.set(highlight.id, highlight.data);
      setVideoNotes({
        visibility: true,
        type: type || 'model',
        element: element,
      })
    }, 150)
    */
  }
  window.closeVideoNotes = (videoNotes:any)=>{
    // setIsShowVideoPreview(false);
    const arrayVideos = [...arrayDialogVideos];
    // const nIndex = arrayVideos.findIndex(p=>p.id == videoNotes.id);
    // if (nIndex != -1){
    //   arrayVideos.splice(nIndex,1);
    // }
    const arrayVideoNotes = arrayVideos.filter(p=>p.id == videoNotes?.id);
    if (arrayVideoNotes.length == 0)return;

    arrayVideoNotes.forEach(p=>{
      p.visibility = false;
    })

    dialogVideoRefs.current = [];

    //如果全部是0的时候，清空.
    if (arrayVideos.some(p=>p.visibility)){
      setArrayDialogVideos(arrayVideos);
    }else{
      setArrayDialogVideos([])
    }
  }

  window.bringDialogVideoFront = (videoNotes:any)=>{
    var arrayVideos = [...arrayDialogVideos];
    const bringVideo = arrayVideos.find(p=>p.id == videoNotes.id);
    if (bringVideo){
      bringVideo.zIndex = ++mDialogZIndex;
    }
    dialogVideoRefs.current = [];
    setArrayDialogVideos(arrayVideos);
  }

  /**
   * 关闭未置顶的窗口
   */
  window.closeUnpinDialogVideos = ()=>{
    if (arrayDialogVideos.length == 0)return;
    const arrayVideos = [...arrayDialogVideos];
    for (let i=0;i<dialogVideoRefs.current.length;i++){
      const ref = dialogVideoRefs.current[i];
      //如果未置顶，则关闭
      if (!ref.getIsPin()){
        const data = ref.getData();
        const nIndex = arrayVideos.findIndex(p=>p.id == data.id);
        if (nIndex != -1){
          arrayVideos.splice(nIndex,1);
        }
      }
    }

    dialogVideoRefs.current = [];
    global.g_showDialogs['dialogVideoNotes'] = (arrayVideos.length > 0);
    setArrayDialogVideos(arrayVideos);
  }

  //显示或隐藏Video浮窗----
  window.showOrHiddenFloatVideoWindow = ()=>{
    for (let i=0;i<dialogVideoRefs.current.length;i++){
      const cardRef = dialogVideoRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()){
        cardRef.showOrHidden();
      }
    }
  }

  window.getDialogVideosCount = ()=>{
    return arrayDialogVideos.length;
  }

  /**
   * 当前浮窗的pdf数量
   */
  window.getVideoPinCount = ()=>{
    let nPinCount = 0;
    for (let i=0;i<dialogVideoRefs.current.length;i++) {
      const cardRef = dialogVideoRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()) {
        nPinCount ++;
      }
    }
    return nPinCount;
  }

  //endregion****************************多video弹窗***************************end*/


  //region****************************多video弹窗--无注记的****************************/
  /**
   * 显示图片/视频查看
   * @param data
   */
  window.showDialogMediaView = (data)=>{
    if (isInSidebar()){
      window.parent.showDialogMediaView(data);
      return;
    };

    const arrayMedias = [...arrayDialogMedia];
    let item = arrayMedias.find(p=>p.id == data.id);
    if (item){

    }else{
      item = data;
      arrayMedias.push(item);
    }

    item.open = true;
    dialogMediaRefs.current = [];
    item.zIndex = ++mDialogZIndex;
    item.maskLayer = (window.getDialogPinCount() == 0);
    setArrayDialogMedia(arrayMedias);

    // setIsShowDialogMediaView(true);
    // setTimeout(()=>{
    //   dialogMediaViewRef.current?.onShowDialog(data);
    // },100)
  }
  window.closeDialogMediaView = (data:any)=>{
    const arrayVideos = [...arrayDialogMedia];
    const arrayVideoNotes = arrayVideos.filter(p=>p.id == data.id);
    if (arrayVideoNotes.length == 0)return;

    arrayVideoNotes.forEach(p=>{
      p.open = false;
    })

    dialogMediaRefs.current = [];

    //如果全部是0的时候，清空.
    if (arrayVideos.some(p=>p.open)){
      setArrayDialogMedia(arrayVideos);
    }else{
      setArrayDialogMedia([])
    }
  }

  window.bringDialogMediaFront = (data:any)=>{
    var arrayVideos = [...arrayDialogMedia];
    const bringVideo = arrayVideos.find(p=>p.id == data.id);
    if (bringVideo){
      bringVideo.zIndex = ++mDialogZIndex;
    }
    dialogMediaRefs.current = [];
    setArrayDialogMedia(arrayVideos);
  }

  //显示或隐藏Video浮窗----
  window.showOrHiddenFloatMediaWindow = ()=>{
    for (let i=0;i<dialogMediaRefs.current.length;i++){
      const cardRef = dialogMediaRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()){
        cardRef.showOrHidden();
      }
    }
  }

  window.getDialogMediasCount = ()=>{
    return arrayDialogMedia.length;
  }

  /**
   * 当前浮窗的pdf数量
   */
  window.getMediaPinCount = ()=>{
    let nPinCount = 0;
    for (let i=0;i<dialogMediaRefs.current.length;i++) {
      const cardRef = dialogMediaRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()) {
        nPinCount ++;
      }
    }
    return nPinCount;
  }

  //endregion****************************多video弹窗***************************end*/

  //region****************************多textedit弹窗和sticynotes****************************/

  /**
   * 显示图片/视频查看
   * @param data
   */
  window.showDialogTiptapTextEditorView = (data)=>{
    if (isInSidebar()){
      window.parent.showDialogTiptapTextEditorView(data);
      return;
    };

    const arrayMedias = [...arrayDialogTiptapEditor];
    let item = arrayMedias.find(p=>p.id == data.id);
    if (item){

    }else{
      item = data;
      arrayMedias.push(item);
    }

    item.open = true;
    dialogTiptapTextEditorRefs.current = [];
    item.zIndex = ++mDialogZIndex;
    item.maskLayer = (window.getDialogPinCount() == 0);
    setArrayDialogTiptapEditor(arrayMedias);
  }
  window.closeDialogTiptapTextEditorView = (data:any)=>{
    const arrayVideos = [...arrayDialogTiptapEditor];
    const arrayVideoNotes = arrayVideos.filter(p=>p.id == data.id);
    if (arrayVideoNotes.length == 0)return;

    arrayVideoNotes.forEach(p=>{
      p.open = false;
    })

    dialogTiptapTextEditorRefs.current = [];

    //如果全部是0的时候，清空.
    if (arrayVideos.some(p=>p.open)){
      setArrayDialogTiptapEditor(arrayVideos);
    }else{
      setArrayDialogTiptapEditor([])
    }
  }

  window.bringDialogTiptapTextEditorFront = (data:any)=>{
    var arrayVideos = [...arrayDialogTiptapEditor];
    const bringVideo = arrayVideos.find(p=>p.id == data.id);
    if (bringVideo){
      bringVideo.zIndex = ++mDialogZIndex;
    }
    dialogTiptapTextEditorRefs.current = [];
    setArrayDialogTiptapEditor(arrayVideos);
  }

  //显示或隐藏Video浮窗----
  window.showOrHiddenFloatTiptapTextEditorWindow = ()=>{
    for (let i=0;i<dialogTiptapTextEditorRefs.current.length;i++){
      const cardRef = dialogTiptapTextEditorRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()){
        cardRef.showOrHidden();
      }
    }
  }

  window.getDialogTiptapTextEditorCount = ()=>{
    return dialogTiptapTextEditorRefs.length;
  }

  /**
   * 当前浮窗的pdf数量
   */
  window.getTiptapTextEditorPinCount = ()=>{
    let nPinCount = 0;
    for (let i=0;i<dialogTiptapTextEditorRefs.current.length;i++) {
      const cardRef = dialogTiptapTextEditorRefs.current[i];
      //如果未置顶，则关闭
      if (cardRef.getIsPin()) {
        nPinCount ++;
      }
    }
    return nPinCount;
  }

  //endregion*****************************多textedit弹窗和sticynotes***************************end*/


  /**
   * 是否有窗口在显示
   */
  window.hasDialogShow = ()=>{
    let nOpenDialogCount = 0;
    Object.keys(global.g_showDialogs).forEach(p=>{
      if (global.g_showDialogs[p]){
        console.log('openDialogs:true',p);
        nOpenDialogCount ++;
      }
    })
    return window.getDialogCardsCount() > 0 ||
        window.getDialogPdfsCount() >0 ||
        window.getDialogVideosCount()>0 ||
        window.getDialogMediasCount() > 0 ||
        nOpenDialogCount > 0;
  }

  /**
   * 显示添加到库中的链接内容
   */
  window.showDialogAddToLibrary = (libraryData:any,callback:any,szTipMessage:any)=>{
    setIsShowDialogAddToLibrary(true);
    setTimeout(()=>{
      dialogAddToLibraryRef.current?.onShowDialog(libraryData,callback,szTipMessage);
    },200)
  }
  window.closeDialogAddToLibrary = ()=>{
    setIsShowDialogAddToLibrary(false);
  }

  /**
   * 显示其他页面的粘贴
   * @param libraryData
   * @param callback
   * @param szTipMessage
   */
  window.showDialogPasteMediaAddTo = (libraryData:any,callback:any,szTipMessage:any)=>{
    setIsShowDialogPasteMediaAddTo(true);
    setTimeout(()=>{
      dialogPasteMediaAddToRef.current?.onShowDialog(libraryData,callback,szTipMessage);
    },200)
  }
  window.closeDialogPasteMediaAddTo = ()=>{
    setIsShowDialogPasteMediaAddTo(false);
  }

  window.showDialogCreateNewFilter = (szId:any)=>{
    setIsShowDialogCreateNewFilter(true);
    setTimeout(()=>{
      dialogCreateNewFilterRef.current?.onShowDialog(szId);
    },200)
  }
  window.closeDialogCreateNewFilter = ()=>{
    setIsShowDialogCreateNewFilter(false);
  }

  window.showDialogImageCrop = (szImagePath,callback:any,fRate)=>{
    setIsShowDialogImageCrop(true);
    setTimeout(()=>{
      dialogImageCropRef.current?.onShowDialog(szImagePath,callback,fRate);
    },200)
  }
  window.closeDialogImageCrop = ()=>{
    setIsShowDialogImageCrop(false);
  }

  /**
   * 选择projectlink的图片--每一种选择都不一样。没有统一的设计。
   * @param szImagePath
   * @param callback
   */
  window.showDialogChooseProjectLinkImage = (szImagePath,callback:any)=>{
    setIsShowDialogChooseImageNew(true);
    setTimeout(()=>{
      dialogChooseProjectLinkImageRef.current?.onShowDialog(szImagePath,callback);
    },200)
  }
  window.closeDialogChooseProjectLinkImage = ()=>{
    setIsShowDialogChooseImageNew(false);
  }

  /**
   * 显示添加链接
   */
  window.showDialogAddLink = (link)=>{
    setIsShowDialogAddLink(true);
    setTimeout(()=>{
      dialogAddLinkRef.current?.onShowDialog(link);
    },200)
  }
  window.closeDialogAddLink = ()=>{
    setIsShowDialogAddLink(false);
  }

  /**
   * 显示添加属性
   */
  window.showDialogAddProperty = (property,callback)=>{
    setIsShowDialogAddProperty(true);
    setTimeout(()=>{
      dialogAddPropertyRef.current?.onShowDialog(property,callback);
    },200)
  }
  window.closeDialogAddProperty = ()=>{
    setIsShowDialogAddProperty(false);
  }

  /**
   * 添加视图--
   * @param property
   */
  window.showDialogAddView = (view,tagName,callback,lastView)=>{
    setIsShowDialogAddView(true);
    setTimeout(()=>{
      dialogAddViewRef.current?.onShowDialog(view,tagName,callback,lastView);
    },200)
  }
  window.closeDialogAddView = ()=>{
    setIsShowDialogAddView(false);
  }

  /**
   * 添加关联--
   * @param property
   */
  window.showDialogRelatedProperty = (property,callback)=>{
    setIsShowDialogRelatedProperty(true);
    setTimeout(()=>{
      dialogRelatedPropertyRef.current?.onShowDialog(property,callback);
    },200)
  }
  window.closeDialogRelatedProperty = ()=>{
    setIsShowDialogRelatedProperty(false);
  }

  /**
   * 修改项目的缩略图.
   * @param item
   * @param szImgName
   */
  window.showDialogChooseThumb = (item:any,callback:any)=>{
    setIsShowDialogChooseThumb(true);

    setTimeout(()=>{
      dialogChooseThumbRef.current?.onShowDialog((szImgName: any) => {
        //更新这个缩略图
        item.thumbUrl = szImgName;
        if (item.type == 'board'){
          //更新
          updateBoard(item).then(res=>{
            if (callback){
              callback(item);
            }
          });
        }else{
          //更新
          updateNote(item).then(res=>{
            if (callback){
              callback(item);
            }
          });
        }
      });
    },200)
  }

  /**
   * 移动board----
   * @param item
   * @param callback
   */
  window.showDialogBoardMoveTo = (board:any,canvas,projectId,callback:any)=>{
    setIsShowDialogMoveTo(true);

    setTimeout(()=>{

      loop(canvas, board.key, (item, index, type, parent) => {
        var newItem = Object.assign({}, item);
        newItem.key = nanoid();
        newItem.drawJson = item.drawJson;
        newItem.icon = '';

        dialogMoveToRef.current?.onShowDialog(newItem,board.key,canvas,projectId, async(szOperator:any,selectProject)=>{
          if (szOperator == 'delete'){
            //删除当前key--
            const projectDoc = await getNoteJsonDoc(projectId);
            loop(projectDoc.canvas, board.key, async (item, num, node, parent) => {
              if (parent){
                parent.children.splice(num,1);
              }else{
                projectDoc.canvas.splice(num,1);
              }
              //保存..
              updateNoteDoc({id:projectId,doc:projectDoc});
              const dbProjectBoard = await getBoardById(board.key);
              //刷新列表...
              dbProjectBoard.isDeleted = 1;
              dbProjectBoard.isFavirated = 0;
              updateBoard(dbProjectBoard).then(res=>{
                window.globalRefreshList('refresh_tableview_single_data_',dbProjectBoard.id,{type:'board'});

                //直接删了...
                setTimeout(()=>{
                  deleteBoardById(dbProjectBoard.id).then(rr=>{
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                  });
                },600)
              })
            });
          }
        });
      });

    },200)

  }


  /**
   * 添加web书签--
   * @param property
   */
  window.showDialogWebBrowseAddBookmark = (data,callback)=>{
    setIsShowDialogWebBrowseAddBookmark(true);
    setTimeout(()=>{
      dialogWebBrowseAddBookmarkRef.current?.onShowDialog(data,callback);
    },200)
  }
  window.closeDialogWebBrowseAddBookmark = ()=>{
    setIsShowDialogWebBrowseAddBookmark(false);
  }

  /**
   * 显示frame排序....
   * @param arrayFrames
   */
  window.showDialogFramePreview = (szBoardId,arrayFrames,callback)=>{
    setIsShowDialogFramePreview(true);
    setTimeout(()=>{
      dialogFramePreviewRef.current?.onShowDialog(szBoardId,arrayFrames,callback);
    },200)
  }
  window.closeDialogWebBrowseAddBookmark = ()=>{
    setIsShowDialogFramePreview(false);
  }

  /**
   * 显示发布card弹窗
   * @param szCardId
   * @param callback
   */
  window.showDialogPublishCardToWeb = (szCardId,callback)=>{
    setIsShowDialogPublishCard(true);
    setTimeout(()=>{
      dialogPublishToWebRef.current?.onShowDialog(szCardId,(szId)=>{
        callback(szId,dialogPublishToWebRef);
      });
    },200)
  }

  /**
   * 显示发布card弹窗
   * @param szCardId
   * @param callback
   */
  window.showDialogEditTranscript = (transcript,item:any,callback)=>{
    setIsShowDialogEditTranscript(true);
    setTimeout(()=>{
      dialogEditTranscriptRef.current?.onShowDialog(transcript,item,(transcript)=>{
        callback(transcript);
      });
    },200)
  }

    /**
     * 显示字幕替换
     * @param szCardId
     * @param callback
     */
    window.showDialogReplace = (searchKey,transcript,callback)=>{
        setIsShowDialogReplace(true);
        setTimeout(()=>{
            dialogReplaceRef.current?.onShowDialog(searchKey,transcript,(transcript)=>{
                callback(transcript);
            });
        },200)
    }


    /**
     * 显示思维导图导入markdown
     * @param szCardId
     * @param callback
     */
    window.showDialogImportMindmapFromMd = (callback)=>{
        setIsShowDialogImportMindmapFromMarkdown(true);
        setTimeout(()=>{
            dialogImportMindmapFromMarkdownRef.current?.onShowDialog((data)=>{
                callback(data);
            });
        },200)
    }

    /**
     * 关闭导入思维导图
     */
    window.closeDialogImportMindmapFromMd = ()=>{
        setIsShowDialogImportMindmapFromMarkdown(false);
        setTimeout(()=>{
            global.g_showDialogs.dialogImportMindmapFromMd = false;
        },2000)
    };


  /**
   * 显示思维导图导入markdown
   * @param szCardId
   * @param callback
   */
  window.showDialogBoardVisible = (treeData,callback)=>{
    setIsShowDialogBoardVisible(true);
    setTimeout(()=>{
      dialogBoardVisibleRef.current?.onShowDialog(treeData,(data)=>{
        callback(data);
      });
    },200)
  }

  /**
   * 显示库中文件的预览
   */
  window.showLibraryFilePreview = (data:any,searchKey)=>{
    if (data.type == 'pdf'){
      window.showPdfPreview(data.name,data.id,data.fileName);
    }else if (data.type == 'image'){
      window.showDialogMediaView(data);
    }else if (data.type == 'video'){
      window.showDialogMediaView(data);
    }else if (data.type == 'card' || data.type == 'journal'){
      window.showDialogCard(data);
    }else if (data.type == 'pdfAnno' || data.type == 'cardAnno') {
      window.showDialogPdfAnno(data);
    }else if (data.type == 'videoAnno' || data.type == 'audioAnno') {
      window.showDialogVideoAnno(data);
    }else if (isSupportVideoAnnoUrl(data.fileName)){
      window.showVideoNotes({...data,data:[],type:data.type || 'youtube'});
    }
    else{
      let szFilePath = localStorage.getItem(KEY_FILE_DIR) + data.fileName;
      if (data.isAbsolutePath || isAbsoluteFilePath(data.fileName)) {
        szFilePath = data.fileName;
      }
      ipcInvoke('open-url-withwhen', szFilePath).then(res => {
        if (res == 'error') {
          message.error(t("Open error"));
        }
      })
    }
  }

  window.handleALink = (event,szHref)=>{
    if (szHref.startsWith('javascript')){
      message.error(t("Invalid link"))
      return false;
    }
    if (szHref.startsWith(window.location.origin)){
      szHref = szHref.replace("file:///",'').replace(window.location.origin,'');//windows的开头j file:///路径....
      if (isAbsoluteFilePath(szHref)){
        if (isImage(szHref)){
          window.showImagePreview(szHref);
        }else{
          ipcInvoke('open-url-withwhen',decodeURIComponent(szHref));
        }
      }else{
        message.error('invalid link...');
      }

      return false;
    }
    if (checkIfAbsolute(szHref)){
      //本地路径...
      ipcInvoke('open-url-withwhen',decodeURIComponent(szHref));
      return false;
    }
    const deeplink = decodeDeeplink(szHref);
    //已经处理过.
    global.g_handleCardDeeplink = szHref;
    if (deeplink.type == 'library' || deeplink.type == 'highlight') {
      postMessage(EVENT_OPEN_LIBRARY_ITEM, {
        id: deeplink.id,
        from: FROM_LIBRARY,
        deeplink: deeplink,
        inSlider:(event.metaKey || event.ctrlKey),
        selectedId:deeplink.childId
      })
    }
    else {
      deepLinkToLinkInfo(deeplink).then(linkInfo=>{
        postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo:linkInfo,inSlider:(event.metaKey || event.ctrlKey)});
      });
    }
  }


  /**
   * 处理A链接
   */
  window.hookATags = ()=>{
    return;
    const arrayA = document.getElementsByTagName('a');
    for (let i=0;i<arrayA.length;i++){
      const a = arrayA[i];
      if (!a.href || !isString(a.href))continue;
      // if (a.href?.startsWith(window.location.origin)){
      //   a.href = 'javascript:(return false)';//`javascript:(alert('${t("Invalid link")}'))`
      // }
      let szHref = a.href?.replace("file:///",'').replace(window.location.origin,'') || '';
      if ((isString(szHref) && (szHref.startsWith('noteey://open?')) ||
          checkIfAbsolute(szHref)) ||
          a.href?.startsWith(window.location.origin)){
        a.onclick = function (event:any){
          event.preventDefault();
          if (event.currentTarget.href.startsWith('javascript')){
            message.error(t("Invalid link"))
            return false;
          }
          if (event.currentTarget.href.startsWith(window.location.origin)){
            const szHref = event.currentTarget.href.replace("file:///",'').replace(window.location.origin,'');//windows的开头j file:///路径....
            if (isAbsoluteFilePath(szHref)){
              if (isImage(szHref)){
                window.showImagePreview(szHref);
              }else{
                ipcInvoke('open-url-withwhen',decodeURIComponent(szHref));
              }
            }else{
              message.error('invalid link...');
            }

            return false;
          }
          if (checkIfAbsolute(szHref)){
            //本地路径...
            ipcInvoke('open-url-withwhen',decodeURIComponent(szHref));
            return false;
          }
          const deeplink = decodeDeeplink(event.currentTarget.href);
          //已经处理过.
          global.g_handleCardDeeplink = event.currentTarget.href;
          if (deeplink.type == 'library' || deeplink.type == 'highlight') {
            postMessage(EVENT_OPEN_LIBRARY_ITEM, {
              id: deeplink.id,
              from: FROM_LIBRARY,
              deeplink: deeplink,
              inSlider:(event.metaKey || event.ctrlKey),
              selectedId:deeplink.childId
            })
          }
          else {
            deepLinkToLinkInfo(deeplink).then(linkInfo=>{
              postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo:linkInfo,inSlider:(event.metaKey || event.ctrlKey)});
            });
          }

          return false;
        }
      }
    }
  }

  /**
   * 添加库里面的条目到项目中...
   */
  window.insertItemsToProject = (project:any,arrayItems:any,hasTips)=>{
    insertChooseProject(project,arrayItems,hasTips);
  }

  /**
   * 主题配置.
   */
  function initThemeData(){
    const theme = localStorage.getItem(SYS_CONFIG_KEY_THEME);
    let body = document.getElementsByTagName("body")[0];
    if(theme){
      const szThemeName = theme + '-theme';
      body.className = szThemeName;
      global.g_isDarkMode = (theme == THEME_DARK);
    }else{
      body.className = 'light-theme';
    }
  }

  //初始化字体列表
  function initFontFamilyList(){
    var style = document.createElement('style');
    style.type = 'text/css';
    fontInfoList().then(res=>{
      Global.g_arrayFonts.length = 0;
      res.sort((a,b)=>{
        return b.createTime - a.createTime;
      })
      Global.g_arrayFonts.push(...res);
      for (let i=0;i<res.length;i++){
        const font = res[i];
        var cssContent = document.createTextNode('@font-face { font-family: "'+ font.fontName+'"; src: url("localfont://'+ font.fontPath+'"); }');
        style.appendChild(cssContent);

        FONT_FAMILY[font.fontName] = font.fontName;

        //创建一个无用的span 强制加载字体....
        var span = document.createElement('span');
        span.style.fontFamily = font.fontName;
        document.body.appendChild(span);
      }
      document.head.appendChild(style);
    })
  }

  /**
   * 是否在右侧栏
   */
  const isInSidebar = ()=>{
    return window.location.href.includes('sliderDraw');
  }

  /**
   * 插入选择的library到项目中
   * 插入到项目
   * 添加到项目
   *
   * 添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目添加到项目
   * @param project
   * @param arraySelectItems
   */
  async function insertChooseProject(project,arraySelectItems,hasTips = true){
    let doc;
    const isNew = project.isCreateNew;

    if (isInDraw() && project.id == PROJECT_ID){
      //
      window.insertItemToThisProject(project,arraySelectItems);
      return;
    }

    if (isNew) {
      if (await hasBeyondFreeLimit()){
        postMessage(EVENT_SHOW_DESKTOP_PRO_VIP,{from:''})
        return;
      }
      //添加一个空白的project...
      project = createEmptyProject(project.id,project.name || '');
      doc = {doc:project.doc};
    }else {
      doc = await getNoteDoc(project.id);
    }
    let jsonDoc:any;
    if (isString(doc.doc)){
      jsonDoc= JSON.parse(doc.doc);
    }else{
      jsonDoc = doc.doc;
    }

    //取第一个board---有可能第一个是文件夹.
    let firstCanvas:any = null;
    loopAllNode(jsonDoc.canvas,(node)=>{
      if (!firstCanvas && node.drawJson?.elements){
        if (project.id != project.key){
          //选中的是一个board
          if (node.key == project.key){
            firstCanvas = node;
          }
        }else{
          firstCanvas = node;
        }
      }
    })

    if (firstCanvas == null){
      firstCanvas = jsonDoc.canvas[0];
    }

    let nOffsetX = 0,nOffsetY = 0;
    //收集所有的元素id
    const arrayNewElementIds:any = [];

    for (let i=0;i<arraySelectItems.length;i++) {
      //region forfor
      const item = arraySelectItems[i];
      //插入到画布
      let ptX = (document.body.clientHeight - 280)*0.5 + nOffsetX;
      let ptY = 210 + nOffsetY;
      //第1个画布，如果存在就继续下一个....
      //todo...

      if (item.type == 'card' || item.type == 'journal') {
        //region 添加到该项目的card
        const itemNew =  {
          title:item.name,
          editValue:item.name,
          key:item.id,
          icon:'',
          isFolder:false,
          isEditable:false,
          noteDataDoc:'',
          hasUpdate:true,
          createTime:Date.now(),
          updateTime:Date.now()
        };
        if(!jsonDoc.notes){
          jsonDoc.notes = [];
        }
        if (!jsonDoc.notes.some(p=>p.key == item.id)){
          jsonDoc.notes.push(itemNew);
        }

        let w = DEFAULT_NOTE_WIDTH,h = DEFAULT_NOTE_HEIGHT;
        ptX += w;

        const szDefaultStyle = localStorage.getItem(KEY_CARD_ELEMENT_DEFAULT_STYLE);
        let defaultStyle = {strokeWidth:2,strokeColor:'transparent',backgroundColor:getNoteElementBackgroundColor()};
        if (szDefaultStyle){
          const jsonDefaultStyle = JSON.parse(szDefaultStyle);

          if (jsonDefaultStyle.backgroundColor){
            defaultStyle.backgroundColor = jsonDefaultStyle.backgroundColor;
          }
          if (jsonDefaultStyle.strokeWidth){
            defaultStyle.strokeWidth = jsonDefaultStyle.strokeWidth;
          }
          if (jsonDefaultStyle.strokeColor){
            defaultStyle.strokeColor = jsonDefaultStyle.strokeColor;
          }
        }

        let element = {
          type: "iframe",
          version: 1,
          isDeleted: false,
          id: generateUUID2(),
          strokeWidth: item.strokeWidth || defaultStyle.strokeWidth,
          strokeStyle: "solid",
          roughness:0,
          roundness: {
            type:ROUNDNESS.ADAPTIVE_RADIUS,
            value:8
          },
          opacity: 100,
          angle: 0,
          locked:false,
          x: ptX,
          y: ptY,
          backgroundColor:item.backgroundColor || defaultStyle.backgroundColor,//getNoteElementBackgroundColor(),
          strokeColor:item.strokeColor || defaultStyle.strokeColor,//getNoteElementStrokeColor(),
          fillStyle:'solid',
          width: w,
          height: h,
          groupIds: [],
          customData: {
            generationData: {
              status: 'done',
              html: '',
              name:'',
              type:item.type == 'card'?'note':'journal',
              libraryType:item.type == 'card'?'note':'journal',
              formatDate:item.formatDate,
              id:item.id,
              isEditable:true,
              isExpand:true,
              isFixedSize:false,
            }
          }
        }
        //添加到第一个board
        firstCanvas.drawJson.elements.push(element);
        //endregion
      }else if (item.type == 'image') {
        //region 以图片的方式插入....
        // let ptX = (document.body.clientHeight - 280)*0.5;
        // let ptY = 210;

        let isSvgExt = isSvg(item.fileName);
        let szBase64 = await ipcInvoke('read-file-base64',{filePath:(localStorage.getItem(KEY_FILE_DIR)+item.fileName)});
        szBase64 = `data:image/${isSvgExt?'svg+xml':getFileNameExt(item.fileName)};base64,`+szBase64
        let w = 280,h = 210;
        const imgSize = await getBase64ImageSize(szBase64);
        w = DEFAULT_NOTE_WIDTH;
        h = w*imgSize?.height/imgSize?.width;
        if (!h){
          h = w*1.4;
        }
        // ptX += w;
        let element = {
          type: "image",
          version: 1,
          isDeleted: false,
          id: generateUUID2(),//这里使用新的ID，原始ID保存到customData里面,
          fileId:getFileNameWithoutExt(item.fileName),
          strokeWidth: 0.0000001,
          strokeStyle: "solid",
          roughness:0,
          roundness: {
            type:ROUNDNESS.ADAPTIVE_RADIUS,
            value:12
          },
          opacity: 100,
          angle: 0,
          locked:false,
          x: ptX,
          y: ptY,
          strokeColor: "white",
          backgroundColor: "white",
          fillStyle:'solid',
          width: w,
          height: h,
          groupIds: [],
          isLockRatio:true,
          isHidden:false,
          customData:{
            generationData:{
              id:item.id,
              name:item.name
            }
          }
        }
        //添加到第一个board
        firstCanvas.drawJson.elements.push(element);
        if(!firstCanvas.drawJson.files || isArray(firstCanvas.drawJson.files)) {
          firstCanvas.drawJson.files = {};
        }

        var newFile = {
          mimeType: isSvgExt?'image/svg+xml':`image/${getFileNameExt(item.fileName)}`,
          id: element.fileId,
          dataURL: isSvgExt?szBase64:'',
          created: Date.now(),
          lastRetrieved: Date.now(),
          fullPath:item.isAbsolutePath?item.fileName:''
        }

        firstCanvas.drawJson.files[newFile.id] = (newFile)
        //endregion
      }else if (item.type == 'pdfAnno' || item.type == 'cardAnno'){
        //region pdfanno
        const szHtml = createPdfAnnoTextElement(item);
        let height = 210;
        let elementHeight = height;
        if (item.type == 'image' || item.annoType == 'image'){
          let szBase64Image = item.image;
          if (!item.image && item.thumbImage){
            const filePath = localStorage.getItem(KEY_FILE_DIR)+item.id+'.png';
            szBase64Image = 'data:image/png;base64,' + await ipcInvoke('read-file-base64',{filePath:filePath});
          }
          const size = await getBase64ImageSize(szBase64Image,);
          height = (size.height/size.width) * (DEFAULT_NOTE_WIDTH - 24) + 28;
          elementHeight = height;//不包含注记的高度
          height += calcTextAreaHeight((DEFAULT_NOTE_WIDTH - (2 + 8 + 6)*2),item.comment);
        }else{
          //文本，计算下高度.
          const hhhhhhiiiigggggg = calcTextHeight((DEFAULT_NOTE_WIDTH - (8 + 8 + 6) * 2), szHtml);
          const nCommentHeight = calcTextAreaHeight((DEFAULT_NOTE_WIDTH - (2 + 8 + 6)*2),item.comment);
          height = hhhhhhiiiigggggg  + nCommentHeight;//(2 + 8 + 6)这个是所有的padding.
          elementHeight = height;//不包含注记的高度.
        }
        let fileName = item?.name.replace('.pdf','')+'.pdf';
        if (item.type == 'cardAnno'){
          fileName = '';
        }

        var element = {
          type: "iframe",
          version: 1,
          isDeleted: false,
          id: generateUUID2(),
          strokeWidth: 1,
          strokeStyle: "solid",
          roughness:0,
          roundness: {
            type:ROUNDNESS.ADAPTIVE_RADIUS,
            value:8
          },
          opacity: 100,
          angle: 0,
          locked:false,
          x: ptX,
          y: ptY,
          backgroundColor:getNoteElementBackgroundColor(),
          strokeColor:getNoteElementStrokeColor(),
          fillStyle:'solid',
          width: DEFAULT_NOTE_WIDTH,
          height: height,
          groupIds: [],
          customData: {
            generationData: {
              annoHeight:elementHeight,//注记本身高度
              status: 'done',
              html: szHtml,
              type:item.type,
              id:item.libraryId,
              pdfData:item,
              fileName:fileName
            }
          }
        }
        firstCanvas.drawJson.elements.push(element);
        //endregion
      }else if (item.type == 'videoAnno' || item.type == 'audioAnno'){
        //region videoAnno audioAnno
        let height = await calcVideoAnnoHeight(item,DEFAULT_NOTE_WIDTH);
        var element = {
          type: "iframe",
          version: 1,
          isDeleted: false,
          id: generateUUID2(),
          strokeWidth: 1,
          strokeStyle: "solid",
          roughness:0,
          roundness: {
            type:ROUNDNESS.ADAPTIVE_RADIUS,
            value:8
          },
          opacity: 100,
          angle: 0,
          locked:false,
          x: ptX,
          y: ptY,
          backgroundColor:getNoteElementBackgroundColor(),
          strokeColor:getNoteElementStrokeColor(),
          fillStyle:'solid',
          width: DEFAULT_NOTE_WIDTH,
          height: height,
          groupIds: [],
          customData: {
            generationData: {
              // annoHeight:elementHeight,//注记本身高度
              status: 'done',
              html: '',//szHtml,
              type: item.type,
              id:item.libraryId,
              videoData:item,
              videoName:item.name
            }
          }
        }
        firstCanvas.drawJson.elements.push(element);
        //endregion
      }else if (item.type == 'youtube' || item.type == 'bilibili' || item.type == 'webLink' || item.type == 'baidu'){

        var element = {
          type: "embeddable",
          version: 1,
          isDeleted: false,
          id: generateUUID2(),
          strokeWidth: 1,
          strokeStyle: "solid",
          roughness:0,
          roundness: {
            type:ROUNDNESS.ADAPTIVE_RADIUS,
            value:12
          },
          customData:{
            generationData:{
              id:item.id,
              type:item.type
            }
          },
          link:item.fileName,
          opacity: 100,
          angle: 0,
          x: ptX,
          y: ptY,
          strokeColor: "#F0EFF5",
          backgroundColor: "white",
          fillStyle:'solid',
          width: 380,
          height: DEFAULT_EMBEDABLE_ELEMENT_HEIGHT,
          locked:false,
          groupIds: []
        }
        if (item.type == 'webLink'){
          element.embedType = 'text';
          element.height = DEFAULT_EMBEDABLE_BOOKMARK_HEIGHT;
        }
        firstCanvas.drawJson.elements.push(element);
      }
      else {
        //region 以文件的方式插入....
        let w = 280,h = 210;
        if (isVideo(item.fileName)){
          const wh = await getVideoScale(getLocalFilePath(item.fileName,item.isAbsolutePath));
          w = 400;
          h = w*wh.videoHeight/wh.videoWidth;
        }else if (isPdf(item.fileName)){
          const imgSize = await getBase64ImageSize(item.thumbImage);
          // console.log('get pdf thumb.....end...')
          w = 200;
          h = w*imgSize?.height/imgSize?.width;
          if (!h){
            h = w*1.4;
          }
        }else if (isAudio(item.fileName)){
          //音频
          w = DEFAULT_AUDIO_WIDTH;
          h = DEFAULT_AUDIO_HEIGHT;
        }

        const id = generateUUID2();

        let element = {
          type: "iframe",
          version: 1,
          isDeleted: false,
          id: id,//这里使用新的ID，原始ID保存到customData里面
          strokeWidth: 0.0000001,
          strokeStyle: "solid",
          roughness:0,
          roundness: {
            type:ROUNDNESS.ADAPTIVE_RADIUS,
            value:8
          },
          opacity: 100,
          angle: 0,
          locked:false,
          x: ptX,
          y: ptY,
          strokeColor: "white",
          backgroundColor: "white",
          fillStyle:'solid',
          width: w,
          height: h,
          groupIds: [],
          isLockRatio:true,
          isHidden:false,
          customData: {
            generationData: {
              status: 'done',
              id:item.id,
              html: createFileElementHtml(id,item.fileName,getFileNameWithoutExt(item.fileName),item.thumbImage),
              type:'file',
              fileName:item.fileName,
              name:item.name,
              showName:item.name,
            }
          }
        }
        //添加到第一个board
        firstCanvas.drawJson.elements.push(element);
        //endregion
      }
      const lastElement = firstCanvas.drawJson.elements[firstCanvas.drawJson.elements.length - 1];
      arrayNewElementIds.push(lastElement.id);

      nOffsetX +=  12;
      nOffsetY +=  12;
      //endregion
    }

    let elementId = firstCanvas.drawJson.elements[firstCanvas.drawJson.elements.length -1].id;

    if (isNew) {
      project.doc = (jsonDoc);
      updateNote(project).then(res=>{
        mProjectInfo = project;
        window.onShowMessageTip(t("Added to project").replace("{0}",arraySelectItems.length),()=>{
          let nDelay = 0;
          if (window.exitFullScreen){
            window.exitFullScreen();
            nDelay = 200;
          }
          postMessage(EVENT_RESET_NO_SELECTED);
          global.g_selectElementIds = arrayNewElementIds;
          setTimeout(()=>{
            window.navigate(getDrawPath(),{noteData:mProjectInfo,searchKey:'',linkInfo:{pageId:firstCanvas.key,elementId:elementId,selectedElementIds:arrayNewElementIds}})
          },nDelay)
        });
      });
    }else {
      //update doc
      doc.doc = (jsonDoc);
      mProjectInfo = project;
      updateNoteDoc(doc).then(res=>{
        if (hasTips){
          window.onShowMessageTip(t("Added to project").replace("{0}",arraySelectItems.length),()=>{
            let nDelay = 0;
            if (window.exitFullScreen){
              window.exitFullScreen();
              nDelay = 200;
            }
            postMessage(EVENT_RESET_NO_SELECTED);
            global.g_selectElementIds = arrayNewElementIds;
            setTimeout(()=>{
              window.navigate(getDrawPath(),{noteData:mProjectInfo,searchKey:'',linkInfo:{pageId:firstCanvas.key,elementId:elementId,selectedElementIds:arrayNewElementIds}})
            },nDelay)
          });
        }
      });
    }
  }

  /**
   * 渲染自定义的。。。。
   * 文档外
   * body 内
   *
   */
  const renderCustomTips1 = ()=>{
    return createPortal(<div className={'flex-center'} style={{
      position: 'absolute',
      zIndex: MAX_Z_INDEX,
      left: '50%',
      transform: 'translateX(-50%)',
      top: '80px',
      height: '36px',
      borderRadius: '8px',
      padding: '0 26px',
      minWidth: '180px',
      background: 'var(--dialog-background-color)',
      boxShadow: 'var(--dialog-box-shadow)'
    }}>
      <span>{tipsInfo?.message}</span>
      <span style={{textDecoration: 'none', marginLeft: '22px'}} className={'link-color cursor-pointer'}
            onClick={() => {
              if (tipsInfo.action == 'manageTag') {
                getCardById(tipsInfo?.data?.id).then(res => {
                  if (res) {
                    window.showManageTags([res]);
                  }
                })
              } else if (tipsInfo.action == 'addToProject') {
                if (tipsInfo.data) {//直接回调
                  tipsInfo.data();
                }
              }else if (tipsInfo.action == 'editCard') {
                  if (tipsInfo.data) {
                      tipsInfo.data();
                  }
              }else if (tipsInfo.data) {
                tipsInfo.data();
              }
            }}>{tipsInfo?.buttonTxt}</span>

      {
          tipsInfo?.data?.buttonTxt1 &&
          <span style={{textDecoration: 'none', marginLeft: '22px'}} className={'link-color cursor-pointer'}
                onClick={() => {
                  setShowAddANoteData({...tipsInfo?.data});
                  setTipsInfo(null);
                  setTimeout(() => {
                    const txt = document.getElementById('txt-add-note');
                    if (txt) {
                      txt.focus();
                    }
                  }, 200)
                }}>{tipsInfo?.data?.buttonTxt1}</span>
      }
    </div>,document.body)
  }

  const renderShowNote = ()=>{
    return createPortal(<div className={'flex-col'} style={{
          position: 'absolute',
          zIndex: MAX_Z_INDEX,
          left: '50%',
          transform: 'translateX(-50%)',
          top: '80px',
          height: '180px',
          borderRadius: '8px',
          padding: '16px 20px',
          minWidth: '370px',
          background: 'var(--dialog-background-color)',
          boxShadow: 'var(--dialog-box-shadow)'
        }} onKeyDown={(e) => {
          if (e.key == KEYS.ESCAPE) {
            e.stopPropagation();
            e.preventDefault();
            setShowAddANoteData(null);
          }
        }}>
          <span className={'dialog-title'}>{t("Highlight saved")}</span>
          <div className={'flex-col'} style={{
            border: '1px solid var(--border-color)',
            marginTop: '12px',
            height: '100%',
            borderRadius: '8px',
            overflow: 'hidden'
          }}>
            <textarea id={'txt-add-note'} className={'nofocus-border'} style={{
              resize: 'none',
              flexGrow: '1',
              padding: '8px',
              background: 'transparent',
              color: 'var(--text-color)'
            }} placeholder={t('Add note1')}/>
            <div className={'flex-row-vertical-center'} style={{width: '100%', marginBottom: '10px', marginTop: '10px'}}>
                <span className='flex-center cursor-pointer button-border-gray-style'
                      style={{height: '32px', marginLeft: 'auto', minWidth: '80px'}} onClick={() => {
                  setShowAddANoteData(null);
                }}>{t("Cancel")}</span>
              <span className='button-solid-style flex-center ml-12 cursor-pointer'
                    style={{height: '32px', minWidth: '80px', marginRight: '10px'}}
                    onClick={() => {
                      getCardById(showAddANoteData.id).then((res) => {
                        if (res) {
                          const txt = document.getElementById('txt-add-note');
                          if (txt) {
                            const szValue = txt.value;
                            //添加到card/pdf的注记的笔记
                            res.comment = szValue;
                            updateCard(res).then(async (ret) => {
                              const pdfAnnoData = res;
                              //全局所有的都添加注记...
                              window.globalRefreshList('updateAnnoComment_', res);

                              postMessage(EVENT_REFRESH_LIBRARY_LIST);
                              postMessage(EVENT_REFRESH_PDF_ANNO_COMMENT, {
                                annotations: [pdfAnnoData],
                                fileId: pdfAnnoData.libraryId
                              })
                              //更新这一个注记内容
                              await ipcInvoke('save-one-annotations', {
                                data: {
                                  pdfId: pdfAnnoData.libraryId,
                                  id: pdfAnnoData.id,
                                  comment: pdfAnnoData.comment
                                }
                              });
                              //这里要重新读取注记....
                              window.globalRefreshList('updatePdfAnnoComment_');
                            })
                          }
                        }
                        setShowAddANoteData(null);
                      })
                    }}>{t("Save")}</span>
            </div>
          </div>
        </div>,document.body)
  }

  /**
   * web上只分享的版本....
   */
  if (APP_WEB) {
    return (
        <>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Draw/>}></Route>
              <Route path="/p" element={<Draw/>}></Route>
              <Route path="/p/:id" element={<Draw/>}></Route>
              <Route path="/p/:id/:p/:subId" element={<Draw/>}></Route>
              <Route path="/cn/p" element={<Draw />}></Route>
              <Route path="/cn/p/:id" element={<Draw/>}></Route>
              <Route path="/cn/p/:id/:p/:subId" element={<Draw/>}></Route>
            </Routes>
          </BrowserRouter>

          {noteServer.useNoteContext()}
          {confirmServer.UseContext()}

          <ImagePreview/>
          {
            arrayDialogCards.map((item, index) => {
              return (
                  <NewNote ref={(el) => {
                    if (el) {
                      dialogCardRefs.current[index] = el;
                    }
                  }} key={item.id} data={item} index={mDialogZIndex + index}/>
              )
            })
          }

          {/*右侧浮动PDF card*/}
          {/*<RightSlider ref={rightSliderRef}/>*/}
        </>
    )
  }

  //缓存youtube--bilibili 缩略图
  // if ('serviceWorker' in navigator){
  //   window.addEventListener('load',()=>{
  //     navigator.serviceWorker.register('./cache/service-work-image.js').then(reg=>{
  //       console.log('service worker registered successed');
  //     }).catch(error=>{
  //       console.log('Service Worker registration failed:', error);
  //     })
  //   })
  // }


  /**
   * 这个是web端全功能离线版本---不需要有后台服务器
   */
  if (APP_WEB_WWW) {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('./cache/service-work.js').then(reg => {
          console.log('service worker registered successed');
        }).catch(error => {
          console.log('Service Worker registration failed:', error);
        })
      })
    }

    return (
        <>
          <Spin spinning={load.spinning} tip={load.tip} style={{height: '100%'}}>
            <BrowserRouter>
              <Routes>
                <Route path="/home" element={<Home/>}>
                  <Route path="defaultProject" element={<Draw projectId={KEY_DEFAULT_PROJECT_ID}/>}></Route>
                  <Route path="project" element={<HomeIndex/>}></Route>
                  <Route path="list" element={<List/>}></Route>
                  <Route path="trash" element={<Trash/>}></Route>
                  <Route path="journal" element={<PageJournal from={FROM_JOURNAL}/>}></Route>
                  <Route path="library" element={<PageLibrary from={FROM_HOME_LIBRARY} type={''}/>}></Route>
                  <Route path="tags" element={<PageTags/>}></Route>
                  <Route path="inbox" element={<PageInbox/>}></Route>
                  <Route path="highlight" element={<PageHighlight/>}></Route>
                  <Route path="task" element={<PageTask/>}></Route>
                  <Route path='property' element={<PageProperty/>}></Route>
                  <Route path='tagItemList' element={<PageTagItemList/>}></Route>

                  <Route path="draw" element={<Draw />} ></Route>
                  <Route path="draw/:id" element={<Draw/>}></Route>
                  <Route path="draw/:id/:p/:subId" element={<Draw/>}></Route>
                  <Route path="p" element={<Draw />}></Route>
                  <Route path="p/:id" element={<Draw/>}></Route>
                  <Route path="p/:id/:boardId/:elementId" element={<Draw/>}></Route>

                  <Route path="card" element={<PageCard/>}></Route>
                  <Route path={'card/:id'} element={<PageCard/>}></Route>
                  <Route path='pagePdf' element={<PagePdf/>}></Route>

                </Route>
                {/*<Route path="/draw" element={<Draw />} ></Route>*/}
                {/*<Route path="/draw/:id" element={<Draw/>}></Route>*/}
                {/*<Route path="/draw/:id/:p/:subId" element={<Draw/>}></Route>*/}
                {/*<Route path="/p" element={<Draw />}></Route>*/}
                {/*<Route path="/p/:id" element={<Draw/>}></Route>*/}
                {/*<Route path="/p/:id/:boardId/:elementId" element={<Draw/>}></Route>*/}
                <Route path="/" element={<Navigate to="/home" />} ></Route>
                <Route path="/pdf/:id" element={<NotePdf />} ></Route>

              </Routes>
            </BrowserRouter>

            {noteServer.useNoteContext()}
            {confirmServer.UseContext()}

            {/*{showEditor && <NewNote/>}*/}
            {/*改为多实例模式*/}
            {
              arrayDialogCards.map((item,index)=>{
                return(
                    <NewNote ref={(el)=>{
                      if (el) {
                        dialogCardRefs.current[index] = el;
                      }
                    }} key={item.id} data={item} index={mDialogZIndex + index}/>
                )
              })
            }

            <RightMenu.Context/>

            <DialogMessageBox ref={dialogMessageBoxRef}/>
            {
                isShowDialogDesktopPro &&
                <DialogDesktopPro ref={dialogDesktopProRef}/>
            }

            <MessageTip ref={messageTipRef}/>

            <ImagePreview />

            <DialogCommonInput ref={dialogInputRef}/>

            <DialogProgress ref={dialogProgressRef}/>

            <DialogProgress ref={dialogProgressRef1}/>

            {
                isShowDialogInfos &&
                <DialogInfos ref={dialogInfosRef} onClose={()=>{
                  setIsShowDialogInfos(false);
                }}/>
            }

            <DialogTagManager ref={dialogTagManagerRef} from={"library"} onDismissCallback={(isTagChange:boolean)=>{
              //标签更改了，需要刷新数据....
              //加了个确定按钮，必须要全部刷新了。。
              postMessage(EVENT_REFRESH_LIBRARY_LIST);
              postMessage(EVENT_REFRESH_LIBRARY_TAG_LIST);
              postMessage(EVENT_REFRESH_INFO_TAG);
              if(window.onCloseManageTag) {
                window.onCloseManageTag()
              }
            }}/>

            {
              //弹出窗口的drawindex..
              ///////// isShowDialogDrawIndex &&

              //   !DEBUG &&
              // <DialogDrawIndex ref={dialogDrawIndexRef} onDismissCallback={()=>{
              //   // setIsShowDialogDrawIndex(false);
              //   setLinkInfo(null);
              // }} linkInfo={linkInfo}/>
            }

            {/*//card里面的插入链接*/}
            <LinkPage ref={dialogCardLinkPageRef}/>

            {
                isShowCardList &&
                <PopupCardList position={linkPosition} onItemSelect={(item:any)=>{
                  //插入link..
                  let szImage = 'deeplink_card.png';
                  let szDeeplink:any='';
                  let szName:any='';
                  if (item.type == 'card') {
                    szDeeplink = createCopyLink('library',item.id,'card',null,null,null,false);
                    szName = getCardTitle(item);
                  }else if (item.type == 'journal') {
                    szImage = 'deeplink_journal.png';
                    szDeeplink = createCopyLink('library',item.id,'journal',null,null,null,false);
                    szName = getCardTitle(item);
                  }else {
                    szName = item.name;
                    szImage = 'deeplink_project.png';
                    let szChildType = null,szChildId = null;
                    if (!item.isProject){
                      szChildType = 'board';
                      szChildId = item.key;
                    }

                    szDeeplink = createCopyLink('project',item.id,szChildType,szChildId,null,null,false);
                  }

                  const $from =  editorRef.current?.state.selection.$from,
                      start = $from.start(),
                      end = $from.pos;
                  const tr =  editorRef.current?.commands.deleteRange({from:(end-1), to:end});

                  global.g_isRefreshLibraryInfoLink = item.type == 'card';

                  editorRef.current?.commands.insertContent(createDeeplinkView(item.id,szDeeplink,szName,szImage));

                  setTimeout(() => {
                    let html = editorRef.current?.getHTML()
                    /** 最后为图片时， 作为p标签 */
                    if (html.endsWith('</deeplink>')) {
                      editorRef.current?.commands.setContent(html + '<p></p>')
                    }
                    //或者这里触发下更改...
                    if (editorRef.current?.forceUpdate){
                      editorRef.current?.forceUpdate();
                    }
                    editorRef.current?.commands.focus();
                  }, 100)
                  // setTimeout(()=>{
                  //   editorRef.current?.commands.insertContent(<p></p>)
                  // },100)

                  setIsShowCardList(false);
                }}/>
            }

            {
                isShowLatexBlock &&
                <PopupLatexBlock position={linkPosition} handleBlur={()=>{
                  setIsShowLatexBlock(false)

                  setTimeout(() => {
                    mEditor.chain().focus().setNodeSelection(latexBlockProps.current?.getPos()).run();
                    //更新到数据库
                    postMessage(EVENT_UPDATE_CANVAS_NOTE_TO_DB,{id:mEditor.id})
                    console.log(mEditor.id+" "+mEditor.getHTML());
                  }, 100)
                }} inputDone={()=>{
                  window.closePopupLatexBlock();

                  setTimeout(() => {
                    mEditor.chain().focus().setNodeSelection(latexBlockProps.current?.getPos()).run();
                    //更新到数据库
                    postMessage(EVENT_UPDATE_CANVAS_NOTE_TO_DB,{id:mEditor.id})
                  }, 200)
                }} onChange={(szContent:any)=>{
                  if (mLatexBlockOnChange){
                    mLatexBlockOnChange(szContent);
                  }
                }} defaultContent={mszDefaultLatexBlockContent}/>
            }

            {
              arrayDialogPdfs.map((item,index)=>{
                return(
                    <FileModal
                        ref={(el)=>{
                          if (el) {
                            dialogPdfRefs.current[index] = el;
                          }
                        }}
                        initialPage={item.initialPage || 1}
                        state={item.state}
                        fileId={item.fileId}
                        fileName={item.fileName}
                        filePath={item.filePath}
                        isFullScreen={item.isFullScreen}
                        isViewAllHighlight={item.isViewAllHighlight}
                        isShowMoreMenu={item.isShowMoreMenu}
                        highlightId={item.highlightId}
                        zIndex={item.zIndex}
                        open={item.open}
                        onClose={(isUpdate,fileId) => {
                          // if (isUpdate) {
                          //
                          // }
                          // setFileState({
                          //   open: false,
                          //   filePath: "",
                          //   fileName: "",
                          //   fileId: "",
                          //   isFullScreen: false,
                          //   isViewAllHighlight: false,
                          //   isShowMoreMenu: false,
                          //   highlightId: ''
                          // })
                          window.closePdfPreview({fileId:fileId})
                        }}
                    />
                )
              })
            }

            {/*视频笔记*/}
            {
              arrayDialogVideos.map((item,index)=>{
                return(
                    <VideoNotes
                        ref={(el)=>{
                          if (el) {
                            dialogVideoRefs.current[index] = el;
                          }
                        }}
                        zIndex={item.zIndex}
                        // @ts-ignore
                        videoNotes={item}
                        onVideoNotes={(actionVideoNotes)=>{
                          setVideoNotes(actionVideoNotes);
                        }}
                        from={FROM_HOME_DIALOG}
                    />
                )
              })

              // isShowVideoPreview &&
              // <VideoNotes
              //     // @ts-ignore
              //     videoNotes={videoNotes}
              //     onVideoNotes={(actionVideoNotes)=>{
              //       setVideoNotes(actionVideoNotes);
              //     }}
              //     from={FROM_HOME_DIALOG}
              //     setToast={''}
              // />
            }


            {
                isShowDialogImportHighlight &&
                <DialogImportHighlight ref={dialogImportHighlightRef} onClose={()=>setIsShowDialogImportHighlight(false)}/>
            }


            {
                isShowDialogChooseProject &&
                <DialogChooseProject ref={dialogChooseProjectRef} onCloseEvent={()=>{
                  setIsShowDialogChooseProject(false);
                }} onOkEvent={(project:any,arraySelectItems:any)=>{
                  insertChooseProject(project, arraySelectItems)
                }}/>
            }


            {
                isShowCardHistory &&
                <DialogCardHistory ref={dialogCardHistoryRef}/>
            }

            {
                isShowProjectHistory &&
                <DialogProjectHistory ref={dialogProjectHistoryRef}/>
            }

            {
                isShowFileImportLoading &&
                <DialogFileImportModeLoading ref={dialogFileImportLoadingRef}/>
            }

            {
                isShowDialogFileImportModeDrag &&
                <DialogDragFileImportMode ref={dialogDragFileImportModeRef} onCloseEvent={()=>{
                  window.closeDialogFileImportDrag();
                }}/>
            }

            {/*{*/}
            {/*    isShowDialogMediaView &&*/}
            {/*    <DialogMediaView ref={dialogMediaViewRef} onCloseCallback={()=>{*/}
            {/*      setIsShowDialogMediaView(false);*/}
            {/*    }}/>*/}
            {/*}*/}

            {
                isShowDialogPdfAnno &&
                <DialogPdfAnno ref={dialogPdfAnnoRef} onClose={()=>{
                  setIsShowDialogPdfAnno(false);
                }}/>
            }

            {
                isShowDialogVideoAnno &&
                <DialogVideoAnno ref={dialogVideoAnnoRef} onClose={()=>{
                  setIsShowDialogVideoAnno(false);
                }}/>
            }

            {
                isShowDialogLink &&
                <DialogLink ref={dialogLinkRef}
                            isShowDialog={isShowDialogLink}
                            onCloseDialog={() => setIsShowDialogLink(false)}
                            onInsertLink={(item:any)=>{
                              if (mDialogLinkCallback){
                                mDialogLinkCallback(item);
                              }
                            }}
                />
            }

            {
              //mindmap插入的链接模式
                isShowDialogMindmapLinkMode &&
                <DialogMindmapLinkMode ref={dialogMindmapLinkModeRef} onCloseEvent={()=>{
                  setIsShowDialogMindmapLinkMode(false);
                }}/>
            }

            {
                isShowDialogMindmapStyleSetting &&
                <DialogMindmapStyleSetting ref={dialogMindmapStyleSettingRef} onCloseCallback={()=>{
                  setIsShowDialogMindmapStyleSetting(false)
                }}/>
            }

            {
                isShowDialogTypeSwitcherSetting &&
                <DialogTypeSwitcherSetting ref={dialogTypeSwitcherSettingRef} onCloseCallback={()=>{
                  setIsShowDialogTypeSwitcherSetting(false);
                }}/>
            }

            {
              //简单的文本编辑。。不显示
              <div style={{position:'fixed',zIndex:'0',visibility:'hidden'}}>
                <SimpleEditor ref={simpleEditorRef}/>
              </div>

            }



          </Spin>

          {/*隐藏的文件选择*/}
          <div className="file-selector">
            <input
                ref={fileSelectRef}
                type="file"
                id="file-input-page-library"
                multiple={false}
                accept={fileAcceptExt}
                style={{display: 'none'}}
                onChange={(event)=>{
                  if (mFileSelectCallback) {
                    mFileSelectCallback(mImportMode,event.target.files);
                  }
                  fileSelectRef.current.value = '';
                }}
            />
          </div>

          {
              loadSpin.spinning &&
              <div className={'flex-center'} style={{
                position: 'fixed',
                zIndex: '9999',
                width: '100%',
                height: '100%',
                left: '0',
                top: '0',
                background: '#33333333'
              }} onClick={()=>{
                window.closeIndicator();
              }}>
                <Spin indicator={IconIndicatorWhite} spinning={loadSpin.spinning} tip={loadSpin.tip}>
                  {/*{loadSpin.tip}*/}
                </Spin>
              </div>
          }

          {
              isShowDialogGlobalSearch &&
              <DialogGlobalSearch ref={dialogGlobalSearchRef} onCloseCallback={()=>{
                setIsShowDialogGlobalSearch(false);
              }}/>
          }

          {/*这里是slider*/}
          {/*右侧浮动PDF card*/}
          <RightSlider ref={rightSliderRef}/>

          {
            //添加添加链接时库中首先显示的.
              isShowDialogAddToLibrary &&
              <DialogAddToLibrary ref={dialogAddToLibraryRef} onCloseCallback={()=>{
                setIsShowDialogAddToLibrary(false);
              }}/>
          }

          {
              isShowDialogPasteMediaAddTo &&
              <DialogPasteMediaAddTo ref={dialogPasteMediaAddToRef} onCloseCallback={()=>{
                setIsShowDialogPasteMediaAddTo(false);
              }}/>
          }

          {
              isShowDialogLibraryImport &&
              <DialogLibraryImport ref={dialogLibraryImport} onCloseCallback={()=>{
                setIsShowDialogLibraryImport(false);
              }}/>
          }

          {
              isShowDialogWeblinkImport &&
              <DialogWeblinkImport ref={dialogWeblinkImport} onCloseCallback={()=>{
                setIsShowDialogWeblinkImport(false);
              }}/>
          }


          {
              isShowDialogChooseImage &&
              <DialogChooseImage ref={dialogChooseImageRef} onOkClicked={(obj:any)=>{
                if (obj.action == 'uploadImage') {
                  fileSelectRef.current?.click();
                }else{
                  var event = {files: [obj.file]};
                  if (mFileSelectCallback){
                    mFileSelectCallback('',event.files);
                  }
                }
              }} from={''}/>
          }

          {
              isShowDialogChooseCardPdf &&
              <DialogChooseCardPdf ref={dialogChooseCardPdfRef} onOkEvent={(data)=>{
                if (mDialogChooseCardPdfCallback){
                  mDialogChooseCardPdfCallback(data);
                }
              }} onCloseEvent={()=>{
                window.closeDialogChooseCardPdf();
              }}/>
          }

          {
              isShowDialogCreateNewFilter &&
              <DialogCreateNewFilter ref={dialogCreateNewFilterRef} onCloseCallback={()=>{
                setIsShowDialogCreateNewFilter(false)
              }}/>
          }

          {
              isShowDialogImageCrop &&
              <DialogImageCrop ref={dialogImageCropRef} onCloseCallback={()=>{
                setIsShowDialogImageCrop(false)
              }}/>
          }

          {
              isShowDialogChooseImageNew &&
              <DialogChooseProjectLinkImage ref={dialogChooseProjectLinkImageRef} onCloseCallback={()=>{
                setIsShowDialogChooseImageNew(false)
              }}/>
          }

          {
              isShowDialogAddLink &&
              <DialogAddLink ref={dialogAddLinkRef} onCloseCallback={()=>{
                setIsShowDialogAddLink(false)
              }}/>
          }

          {
              isShowDialogAddProperty &&
              <DialogAddProperty ref={dialogAddPropertyRef} onCloseCallback = {()=>{
                setIsShowDialogAddProperty(false)
              }}/>
          }

          {
              isShowDialogAddView &&
              <DialogAddView ref={dialogAddViewRef} onCloseCallback = {()=>{
                setIsShowDialogAddView(false);
              }}/>
          }

          {
              isShowDialogRelatedProperty &&
              <DialogRelatedProperty ref={dialogRelatedPropertyRef} onCloseCallback = {()=>{
                setIsShowDialogRelatedProperty(false);
              }}/>
          }

          {
              isShowDialogChooseThumb &&
              <DialogChooseThumb ref={dialogChooseThumbRef} onCloseCallback={()=>{
                setIsShowDialogChooseThumb(false);
              }}/>
          }

          {
              isShowDialogMoveTo &&
              <DialogMoveTo ref={dialogMoveToRef} onCloseCallback={()=>{setIsShowDialogMoveTo(false)}}/>
          }
        </>
    )
  }

  /**
   * 这个是发布到网页，需要有后台服务器的版本。。。。
   */
  if (APP_WEB_SITE){//webapp
    return (
        <>
          <Spin spinning={load.spinning} tip={load.tip} style={{height:'100%'}}>
            <HashRouter>
              <Routes>
                <Route path="/home" element={<Home />} >
                  <Route index element={<HomeIndex />}></Route>
                  <Route path="list" element={<List />} ></Route>
                  <Route path="trash" element={<Trash />} ></Route>
                  <Route path="library" element={<PageLibrary from={FROM_HOME_LIBRARY}/>}></Route>
                  <Route path="tags" element={<PageTags/>}></Route>
                  <Route path="inbox" element={<PageInbox/>}></Route>
                </Route>
                <Route path="/draw" element={<Draw />} ></Route>
                <Route path="/draw/:id" element={<Draw />}></Route>
                <Route path="/draw/:id/:p/:subId" element={<Draw />}></Route>

                <Route path="/p" element={<Draw />}></Route>
                <Route path="/p/:id" element={<Draw />}></Route>
                <Route path="/p/:id/:p/:subId" element={<Draw />}></Route>
                <Route path="/" element={<Navigate to="/home" />} ></Route>
                <Route path="/pdf/:id" element={<NotePdf />} ></Route>
                <Route path="/login" element={<Login/>} ></Route>
                <Route path={'/404'} element={<Page404/>}></Route>

              </Routes>
            </HashRouter>

            {noteServer.useNoteContext()}
            {confirmServer.UseContext()}


            {showEditor && <NewNote/>}
            <RightMenu.Context/>

            <DialogMessageBox ref={dialogMessageBoxRef}/>
            {
                isShowDialogDesktopPro &&
                <DialogDesktopPro ref={dialogDesktopProRef}/>
            }


            <ImagePreview />


            {/*pdfviewer*/}
            <FileModal
                fileId={fileState.fileId}
                fileName={fileState.fileName}
                filePath={fileState.filePath}
                isFullScreen={fileState.isFullScreen}
                isViewAllHighlight={fileState.isViewAllHighlight}
                isShowMoreMenu={fileState.isShowMoreMenu}
                open={fileState.open}
                onClose={(isUpdate) => {
                  if (isUpdate) {

                  }
                  setFileState({
                    open: false,
                    filePath: "",
                    fileName: "",
                    fileId: "",
                    isFullScreen: false,
                    isViewAllHighlight: false,
                    isShowMoreMenu: false,
                    highlightId: ''
                  })
                }}
            />

            <MessageTip ref={messageTipRef}/>

          </Spin>
        </>
    )
  }

  const history = createHashHistory();

  //默认的客户端
  // @ts-ignore
  // @ts-ignore
  // @ts-ignore
  return (
    <>
      {/*<Spin spinning={load.spinning} tip={load.tip} className={'app-default-client-spin'} style={{height:'100%'}}>*/}
        <HashRouter history={history}>
          <Routes key={location.pathname}>
            <Route path="/home" element={<Home />}>
              <Route path="defaultProject" element={<Draw projectId={KEY_DEFAULT_PROJECT_ID}/>} ></Route>
              <Route path="project" element={<HomeIndex />} ></Route>
              <Route path="list" element={<List />} ></Route>
              <Route path="trash" element={<Trash />} ></Route>
              <Route path="journal" element={<PageJournal from={FROM_JOURNAL}/>} ></Route>
              <Route path="library" element={<PageLibrary from={FROM_HOME_LIBRARY} type={''}/>}></Route>
              <Route path="tags" element={<PageTags/>}></Route>
              <Route path="inbox" element={<PageInbox/>}></Route>
              <Route path="highlight" element={<PageHighlight/>}></Route>
              <Route path="task" element={<PageTask/>}></Route>
              <Route path='property' element={<PageProperty/>}></Route>
              <Route path='tagItemList' element={<PageTagItemList/>}></Route>

              <Route path="draw" element={<Draw />} key={location.pathname}></Route>
              <Route path="draw/:id" element={<Draw/>} key={location.pathname}></Route>
              <Route path="draw/:id/:p/:subId" element={<Draw/>}></Route>
              <Route path="p" element={<Draw />}></Route>
              <Route path="p/:id" element={<Draw/>}></Route>
              <Route path="p/:id/:boardId/:elementId" element={<Draw/>}></Route>
              <Route path="cn/p" element={<Draw />}></Route>
              <Route path="cn/p/:id" element={<Draw/>}></Route>
              <Route path="cn/p/:id/:boardId/:elementId" element={<Draw/>}></Route>

              <Route path="card" element={<PageCard/>}></Route>
              <Route path={'card/:id'} element={<PageCard/>}></Route>
              <Route path='pagePdf' element={<PagePdf/>}></Route>

            </Route>
            {/*<Route path="/draw" element={<Draw />} ></Route>*/}
            {/*<Route path="/draw/:id" element={<Draw/>}></Route>*/}
            {/*<Route path="/draw/:id/:p/:subId" element={<Draw/>}></Route>*/}
            {/*<Route path="/p" element={<Draw />}></Route>*/}
            {/*<Route path="/p/:id" element={<Draw/>}></Route>*/}
            {/*<Route path="/p/:id/:boardId/:elementId" element={<Draw/>}></Route>*/}
            <Route path="/" element={<Navigate to="/home" />} ></Route>
            <Route path="/pdf/:id" element={<NotePdf />} ></Route>

            <Route path="/sliderDraw/:id/:boardId/:elementId/:nodeId" element={<Draw/>}></Route>
            <Route path="/sliderDraw/:id/:boardId/:elementId" element={<Draw/>}></Route>
            <Route path="/sliderDraw/:id/:boardId" element={<Draw/>}></Route>
            <Route path="/sliderDraw/:id" element={<Draw/>}></Route>

            {/*//单独的card*/}
            <Route path="/floatCard" element={<NewNote/>}></Route>

          </Routes>
        </HashRouter>

        {noteServer.useNoteContext()}
        {confirmServer.UseContext()}

        {
            isShowDialogGlobalSearch &&
            <DialogGlobalSearch ref={dialogGlobalSearchRef} onCloseCallback={()=>{
              setIsShowDialogGlobalSearch(false);
            }}/>
        }

        {/*{showEditor && <NewNote/>}*/}
        {/*改为多实例模式*/}

        <RightMenu.Context/>

        {
          arrayDialogCards.map((item,index)=>{
            return(
                <NewNote ref={(el)=>{
                  if (el) {
                    dialogCardRefs.current[index] = el;
                  }
                }} key={item.id} data={item} index={mDialogZIndex + index}/>
            )
          })
        }

        <DialogMessageBox ref={dialogMessageBoxRef}/>
        {
            isShowDialogDesktopPro &&
            <DialogDesktopPro ref={dialogDesktopProRef}/>
        }


        <DialogCommonInput ref={dialogInputRef}/>

        <DialogProgress ref={dialogProgressRef}/>

        <DialogProgress ref={dialogProgressRef1}/>

        {
          isShowDialogInfos &&
            <DialogInfos ref={dialogInfosRef} onClose={()=>{
              setIsShowDialogInfos(false);
            }}/>
        }

        <DialogTagManager ref={dialogTagManagerRef} from={"library"} onDismissCallback={(isTagChange:boolean,arraySelectItems)=>{
          //标签更改了，需要刷新数据....
          //加了个确定按钮，必须要全部刷新了。。
          postMessage(EVENT_REFRESH_LIBRARY_LIST);
          postMessage(EVENT_REFRESH_LIBRARY_TAG_LIST);
          postMessage(EVENT_REFRESH_INFO_TAG);

          //刷新tag视图..
          if (isInPageTag()) {
            window.globalRefreshList('refresh_tableview_tag_',arraySelectItems);
          }

          if(window.onCloseManageTag) {
            window.onCloseManageTag()
          }
        }}/>

        {
          //弹出窗口的drawindex..
          ///////// isShowDialogDrawIndex &&

          //   !DEBUG &&
          // <DialogDrawIndex ref={dialogDrawIndexRef} onDismissCallback={()=>{
          //   // setIsShowDialogDrawIndex(false);
          //   setLinkInfo(null);
          // }} linkInfo={linkInfo}/>
        }

        {/*//card里面的插入链接*/}
        <LinkPage ref={dialogCardLinkPageRef}/>

        {
            isShowCardList &&
            <PopupCardList position={linkPosition} onItemSelect={(item:any)=>{
              //插入link..
              let szImage = 'deeplink_card.png';
              let szDeeplink:any='';
              let szName:any='';
              if (item.type == 'card') {
                szDeeplink = createCopyLink('library',item.id,'card',null,null,null,false);
                szName = getCardTitle(item);
              }else if (item.type == 'journal') {
                szImage = 'deeplink_journal.png';
                szDeeplink = createCopyLink('library',item.id,'journal',null,null,null,false);
                szName = getCardTitle(item);
              }else {
                szName = item.name;
                szImage = 'deeplink_project.png';
                let szChildType = null,szChildId = null;
                if (!item.isProject){
                  szChildType = 'board';
                  szChildId = item.key;
                }

                szDeeplink = createCopyLink('project',item.id,szChildType,szChildId,null,null,false);
              }

              const $from =  editorRef.current?.state.selection.$from,
                  start = $from.start(),
                  end = $from.pos;
              if (mIsPopupCardListFromAt.current){//如果是从@进入的popupcardlist 需要删除@  否则不用.
                const tr =  editorRef.current?.commands.deleteRange({from:(end-1), to:end});
              }

              global.g_isRefreshLibraryInfoLink = item.type == 'card';

              editorRef.current?.commands.insertContent(createDeeplinkView(item.id,szDeeplink,szName,szImage));

              setTimeout(() => {
                let html = editorRef.current?.getHTML()
                /** 最后为图片时， 作为p标签 */
                if (html.endsWith('</deeplink>')) {
                  editorRef.current?.commands.setContent(html + '<p></p>')
                }
                //或者这里触发下更改...
                if (editorRef.current?.forceUpdate){
                  editorRef.current?.forceUpdate();
                }
                editorRef.current?.commands.focus();
              }, 100)
              // setTimeout(()=>{
              //   editorRef.current?.commands.insertContent(<p></p>)
              // },100)

              setIsShowCardList(false);
            }}/>
        }

        {
            isShowLatexBlock &&
          <PopupLatexBlock position={linkPosition} handleBlur={()=>{
            setIsShowLatexBlock(false)

            setTimeout(() => {
              mEditor.chain().focus().setNodeSelection(latexBlockProps.current?.getPos()).run();
              //更新到数据库
              postMessage(EVENT_UPDATE_CANVAS_NOTE_TO_DB,{id:mEditor.id})
              console.log(mEditor.id+" "+mEditor.getHTML());
            }, 100)
          }} inputDone={()=>{
            window.closePopupLatexBlock();

            setTimeout(() => {
              mEditor.chain().focus().setNodeSelection(latexBlockProps.current?.getPos()).run();
              //更新到数据库
              postMessage(EVENT_UPDATE_CANVAS_NOTE_TO_DB,{id:mEditor.id})
            }, 200)
          }} onChange={(szContent:any)=>{
            if (mLatexBlockOnChange){
              mLatexBlockOnChange(szContent);
            }
          }} defaultContent={mszDefaultLatexBlockContent}/>
        }

        {/*pdfviewer*/}
        {/*<FileModal*/}
        {/*    fileId={fileState.fileId}*/}
        {/*    fileName={fileState.fileName}*/}
        {/*    filePath={fileState.filePath}*/}
        {/*    isFullScreen={fileState.isFullScreen}*/}
        {/*    isViewAllHighlight={fileState.isViewAllHighlight}*/}
        {/*    isShowMoreMenu={fileState.isShowMoreMenu}*/}
        {/*    highlightId={fileState.highlightId}*/}
        {/*    open={fileState.open}*/}
        {/*    onClose={(isUpdate) => {*/}
        {/*      if (isUpdate) {*/}

        {/*      }*/}
        {/*      setFileState({*/}
        {/*        open: false,*/}
        {/*        filePath: "",*/}
        {/*        fileName: "",*/}
        {/*        fileId: "",*/}
        {/*        isFullScreen: false,*/}
        {/*        isViewAllHighlight: false,*/}
        {/*        isShowMoreMenu: false,*/}
        {/*        highlightId: ''*/}
        {/*      })*/}
        {/*    }}*/}
        {/*/>*/}

        {
          arrayDialogPdfs.map((item,index)=>{
            return(
                <FileModal
                    ref={(el)=>{
                      if (el) {
                        dialogPdfRefs.current[index] = el;
                      }
                    }}
                    fileId={item.fileId}
                    fileName={item.fileName}
                    filePath={item.filePath}
                    isFullScreen={item.isFullScreen}
                    isViewAllHighlight={item.isViewAllHighlight}
                    isShowMoreMenu={item.isShowMoreMenu}
                    highlightId={item.highlightId}
                    zIndex={item.zIndex}
                    initialPage={item.initialPage || 1}
                    state={item.state}
                    open={item.open}
                    onClose={(isUpdate,fileId) => {
                      // if (isUpdate) {
                      //
                      // }
                      // setFileState({
                      //   open: false,
                      //   filePath: "",
                      //   fileName: "",
                      //   fileId: "",
                      //   isFullScreen: false,
                      //   isViewAllHighlight: false,
                      //   isShowMoreMenu: false,
                      //   highlightId: ''
                      // })
                      window.closePdfPreview({fileId:fileId})
                    }}
                />
            )
          })
        }

        {/*视频笔记*/}
        {
          arrayDialogVideos.map((item,index)=>{
            return(
                <VideoNotes
                    ref={(el)=>{
                      if (el) {
                        dialogVideoRefs.current[index] = el;
                      }
                    }}
                    zIndex={item.zIndex}
                    // @ts-ignore
                    videoNotes={item}
                    onVideoNotes={(actionVideoNotes)=>{
                      setVideoNotes(actionVideoNotes);
                    }}
                    from={FROM_HOME_DIALOG}
                />
            )
          })

          // isShowVideoPreview &&
          // <VideoNotes
          //     // @ts-ignore
          //     videoNotes={videoNotes}
          //     onVideoNotes={(actionVideoNotes)=>{
          //       setVideoNotes(actionVideoNotes);
          //     }}
          //     from={FROM_HOME_DIALOG}
          //     setToast={''}
          // />
        }

        {
            // isShowDialogMediaView &&
            // <DialogMediaView ref={dialogMediaViewRef} onCloseCallback={()=>{
            //   setIsShowDialogMediaView(false);
            // }}/>
            arrayDialogMedia.map((item,index)=>{
              return <DialogMediaView data={item} ref={(el)=>{
                if (el){
                  dialogMediaRefs.current[index] = el;
              }}} onCloseCallback={(data)=>{
                window.closeDialogMediaView(data)
              }}/>
            })
        }

      {//画布上文本和stickynote   便利帖
        arrayDialogTiptapEditor.map((item,index)=>{
          return <DialogTiptapTextEditor element={item} ref={(el)=>{
            if (el){
              dialogTiptapTextEditorRefs.current[index] = el;
            }
          }} onCloseCallback={(data)=>{
            window.closeDialogTiptapTextEditorView(data);
          }}/>
        })
      }


        {
          isShowDialogImportHighlight &&
          <DialogImportHighlight ref={dialogImportHighlightRef} onClose={()=>setIsShowDialogImportHighlight(false)}/>
        }

      {
          isShowDialogImportTranscript &&
          <DialogImportTranscript ref={dialogImportTranscriptRef} onClose={()=>setIsShowDialogImportTranscript(false)}/>
      }

        {
          isShowDialogChooseProject &&
            <DialogChooseProject ref={dialogChooseProjectRef} onCloseEvent={()=>{
              setIsShowDialogChooseProject(false);
            }} onOkEvent={(project:any,arraySelectItems:any)=>{
              insertChooseProject(project, arraySelectItems)
            }}/>
        }


        {
          isShowCardHistory &&
            <DialogCardHistory ref={dialogCardHistoryRef}/>
        }

        {
            isShowProjectHistory &&
            <DialogProjectHistory ref={dialogProjectHistoryRef}/>
        }

        {
          isShowFileImportLoading &&
            <DialogFileImportModeLoading ref={dialogFileImportLoadingRef}/>
        }

        {
          isShowDialogFileImportModeDrag &&
            <DialogDragFileImportMode ref={dialogDragFileImportModeRef} onCloseEvent={()=>{
              window.closeDialogFileImportDrag();
            }}/>
        }


        {
          isShowDialogPdfAnno &&
            <DialogPdfAnno ref={dialogPdfAnnoRef} onClose={()=>{
              setIsShowDialogPdfAnno(false);
            }}/>
        }

        {
            isShowDialogVideoAnno &&
            <DialogVideoAnno ref={dialogVideoAnnoRef} onClose={()=>{
              setIsShowDialogVideoAnno(false);
            }}/>
        }

        {
          isShowDialogLink &&
          <DialogLink ref={dialogLinkRef}
                      isShowDialog={isShowDialogLink}
                      onCloseDialog={() => setIsShowDialogLink(false)}
                      onInsertLink={(item:any)=>{
                        if (mDialogLinkCallback){
                          mDialogLinkCallback(item);
                        }
                      }}
          />
        }

        {
          //mindmap插入的链接模式
          isShowDialogMindmapLinkMode &&
            <DialogMindmapLinkMode ref={dialogMindmapLinkModeRef} onCloseEvent={()=>{
              setIsShowDialogMindmapLinkMode(false);
            }}/>
        }

        {
          isShowDialogMindmapStyleSetting &&
            <DialogMindmapStyleSetting ref={dialogMindmapStyleSettingRef} onCloseCallback={()=>{
            setIsShowDialogMindmapStyleSetting(false)
            }}/>
        }

        {
          isShowDialogTypeSwitcherSetting &&
            <DialogTypeSwitcherSetting ref={dialogTypeSwitcherSettingRef} onCloseCallback={()=>{
              setIsShowDialogTypeSwitcherSetting(false);
            }}/>
        }

        {
          //简单的文本编辑。。不显示
            <div style={{position:'fixed',zIndex:'0',visibility:'hidden'}}>
              <SimpleEditor ref={simpleEditorRef}/>
            </div>
        }

      {/*</Spin>*/}

      {/*隐藏的文件选择*/}
      <div className="file-selector">
        <input
            ref={fileSelectRef}
            type="file"
            id="file-input-page-library"
            multiple={false}
            accept={fileAcceptExt}
            style={{display: 'none'}}
            onChange={(event)=>{
              if (mFileSelectCallback) {
                mFileSelectCallback(mImportMode,event.target.files);
              }
              fileSelectRef.current.value = '';
            }}
        />
      </div>

      {
        loadSpin.spinning &&
        <div className={'flex-column-center'} style={{
          position: 'fixed',
          zIndex: '9999',
          width: '100%',
          height: '100%',
          left: '0',
          top: '0',
          background: '#33333333'
        }} onClick={()=>{
          //点击后，过一会才关闭...
          setTimeout(()=>{
            window.closeIndicator();
          },5000)
        }}>
          <Spin indicator={IconIndicatorWhite} spinning={loadSpin.spinning}>
            {/*{loadSpin.tip}*/}
          </Spin>
          {
            loadSpin.tip &&
            <span style={{color:'white',marginTop:"6px"}}>{loadSpin.tip}</span>
          }
        </div>
      }

      {/*这里是slider*/}
      {/*右侧浮动PDF card*/}
      <RightSlider ref={rightSliderRef}/>

      {
        //添加添加链接时库中首先显示的.
        isShowDialogAddToLibrary &&
          <DialogAddToLibrary ref={dialogAddToLibraryRef} onCloseCallback={()=>{
            setIsShowDialogAddToLibrary(false);
          }}/>
      }

      {
        isShowDialogPasteMediaAddTo &&
          <DialogPasteMediaAddTo ref={dialogPasteMediaAddToRef} onCloseCallback={()=>{
            setIsShowDialogPasteMediaAddTo(false);
          }}/>
      }

      {
        isShowDialogLibraryImport &&
          <DialogLibraryImport ref={dialogLibraryImport} onCloseCallback={()=>{
            setIsShowDialogLibraryImport(false);
          }}/>
      }

      {
        isShowDialogWeblinkImport &&
          <DialogWeblinkImport ref={dialogWeblinkImport} onCloseCallback={()=>{
            setIsShowDialogWeblinkImport(false);
          }}/>
      }


      {
          isShowDialogChooseImage &&
        <DialogChooseImage ref={dialogChooseImageRef} onOkClicked={(obj:any)=>{
          if (obj.action == 'uploadImage') {
            fileSelectRef.current?.click();
          }else{
            var event = {files: [obj.file]};
            if (mFileSelectCallback){
              mFileSelectCallback('',event.files);
            }
          }
        }} from={''}/>
      }

      {
          isShowDialogChooseCardPdf &&
          <DialogChooseCardPdf ref={dialogChooseCardPdfRef} onOkEvent={(data)=>{
            if (mDialogChooseCardPdfCallback){
              mDialogChooseCardPdfCallback(data);
            }
          }} onCloseEvent={()=>{
            window.closeDialogChooseCardPdf();
          }}/>
      }

      {
        isShowDialogCreateNewFilter &&
          <DialogCreateNewFilter ref={dialogCreateNewFilterRef} onCloseCallback={()=>{
            setIsShowDialogCreateNewFilter(false)
          }}/>
      }

      {
        isShowDialogImageCrop &&
          <DialogImageCrop ref={dialogImageCropRef} onCloseCallback={()=>{
            setIsShowDialogImageCrop(false)
          }}/>
      }

      {
        isShowDialogChooseImageNew &&
          <DialogChooseProjectLinkImage ref={dialogChooseProjectLinkImageRef} onCloseCallback={()=>{
            setIsShowDialogChooseImageNew(false)
          }}/>
      }

      {
          isShowDialogAddLink &&
          <DialogAddLink ref={dialogAddLinkRef} onCloseCallback={()=>{
            setIsShowDialogAddLink(false)
          }}/>
      }

      {
          isShowDialogAddProperty &&
          <DialogAddProperty ref={dialogAddPropertyRef} onCloseCallback = {()=>{
            setIsShowDialogAddProperty(false)
          }}/>
      }

      {
        isShowDialogAddView &&
          <DialogAddView ref={dialogAddViewRef} onCloseCallback = {()=>{
            setIsShowDialogAddView(false);
          }}/>
      }

      {
          isShowDialogRelatedProperty &&
          <DialogRelatedProperty ref={dialogRelatedPropertyRef} onCloseCallback = {()=>{
            setIsShowDialogRelatedProperty(false);
          }}/>
      }

      {
        isShowDialogChooseThumb &&
        <DialogChooseThumb ref={dialogChooseThumbRef} onCloseCallback={()=>{
          setIsShowDialogChooseThumb(false);
        }}/>
      }

      {
          isShowDialogMoveTo &&
          <DialogMoveTo ref={dialogMoveToRef} onCloseCallback={()=>{setIsShowDialogMoveTo(false)}}/>
      }

      {
        isShowDialogWebBrowseAddBookmark &&
          <DialogWebBrowseAddBookmark ref={dialogWebBrowseAddBookmarkRef} onCloseCallback={()=>{
            setIsShowDialogWebBrowseAddBookmark(false);
          }}/>
      }

      {
          isShowDialogFramePreview &&
          <DialogFramePreview ref={dialogFramePreviewRef} onCloseCallback={()=>{
            setIsShowDialogFramePreview(false);
          }}/>
      }

      {
          isShowDialogPublishCard &&
        <DialogPublishCardToWeb ref={dialogPublishToWebRef} onCloseCallback={()=>{
          setIsShowDialogPublishCard(false);
        }}/>
      }

      {
          isShowDialogEditTranscript &&
          <DialogEditTranscript ref={dialogEditTranscriptRef} onCloseCallback={()=>{
            setIsShowDialogEditTranscript(false);
          }}/>
      }

        {
            isShowDialogReplace &&
            <DialogReplace ref={dialogReplaceRef} onCloseCallback={()=>{
                setIsShowDialogReplace(false);
            }}/>
        }

        {
            isShowDialogImportMindmapFromMarkdown &&
            <DialogImportMindmapFromMarkdown ref={dialogImportMindmapFromMarkdownRef} onClose={()=>{
                setIsShowDialogImportMindmapFromMarkdown(false);
            }}/>
        }

      {
          isShowDialogBoardVisible &&
          <DialogBoardVisible ref={dialogBoardVisibleRef} onClose={()=>{
            setIsShowDialogBoardVisible(false);
          }}/>
      }

      {/*图片预览*/}
      <Image
          width={200}
          style={{ display: 'none' }}
          src=""
          preview={{
            visible:imagePreviewInfo.visible,
            src: imagePreviewInfo.src,
            onVisibleChange: (value) => {
              setImagePreviewInfo({
                ...imagePreviewInfo,
                visible: value
              });
            },
          }}
      />

      <ImagePreview />

      {
          tipsInfo &&
          renderCustomTips1()
      }

      {
          //region 显示add a note
          showAddANoteData &&
          renderShowNote()
      }

      {
        // isShowMessageTipInfo &&
          <MessageTip ref={messageTipRef}/>
      }

      <DatePickerProvider />


      {
        load.spinning &&
        <Spin spinning={load.spinning} tip={load.tip} className={'app-default-client-spin flex-center'} style={{height:'100%',width:'100%',opacity:'1',position:'fixed',left:'0',top:'0'}}/>
      }

      <TemplateDialogProvider />
      <TemplateSelectorProvider />

    </>
  )
}
export default App





























